var textScreens = {
    "general": {
        "mandarin": {
            "0": "开始之前：",
            "1": "1）将浏览窗口设置为全屏（您可以通过在Windows和Linux上按（F11）或在Mac上按组合键（CTRL + CMD + f）来执行此操作。如果以上方法不行，在Chrome浏览器上，则可以转到 查看菜单，然后点击全屏）<br> <br> 2）尽量减少可能会影响您测试期间的表现的分心事物（比如电视，电话等）<br> <br> 3）将自己从电脑显示器置于一臂长的距离空间，并尝试在整个实验过程中保持此距离<br> <br>完成这些操作后，单击完成。",
            "2": "完成",
            "NEXT": "下一步",
            "FINISH": "完成"
        },
        "english": {
            "0": "Before starting:",
            "1": "1) set your browsing window to Full Screen (you can do this by pressing F11 on Windows and Linux or the key combination CTRL+CMD+f on a Mac; if that does not work, in Chrome you can go to the View menu and click Enter Full Screen) <br><br>2) minimize possible distractions (TV, phone, etc.) that may affect your performance during the test <br><br>3) position yourself at arm's length from the monitor and try to maintain this viewing distance throughout the experiment<br><br>When these are done, click DONE.",
            "2": "DONE",
            "NEXT": "NEXT",
            "FINISH": "FINISH"
        },
        "french": {
            "0": "Avant de commencer:",
            "1": "1) Mettez votre fenêtre de navigation en mode plein écran (vous pouvez faire cela en pressant F11 en Windows et Linux, ou en combinant les touches CTRL+CMD+f sur un Mac. Si cela ne fonctionne pas, Chrome vous autorise à vous rendre sur le menu Afficher et à cliquer Activer le mode plein écran). <br><br>2) Minimisez les sources de distraction (TV, téléphone, etc.) qui pourraient affecter votre performance pendant le test. <br><br> 3) Placez-vous à une distance d’une longueur de bras de l’écran et tachez de conserver cette distance durant la totalité de l’expérience.<br><br>Une fois que tout ceci est fait, cliquez OK.",
            "2": "OK",
            "NEXT": "SUIVANT",
            "FINISH": "TERMINER"
        },
        "dutch": {
            "0": "Alvorens van start te gaan:",
            "1": "1) Zet je internetbrowser op Volledig Scherm (je kan dit doen door op F11 te drukken in Windows en Linux of via de toetsencombinatie CTRL+CMD+f op een Mac-computer; indien dat niet lukt, kun je in Chrome via het Beeld-menu klikken op Volledig Scherm Weergave).<br><br>2) Probeer zoveel mogelijk afleidingen (zoals televisie en telefoon) die je performantie kunnen beïnvloeden af te zetten.<br><br>3) Plaats jezelf op armlengte van het scherm en probeer deze houding gedurende het volledige experiment aan te houden.<br><br>Indien dit allemaal gebeurd is, click dan op OK.",
            "2": "OK",
            "NEXT": "VOLGENDE",
            "FINISH": "AFRONDEN"
        },
        "spanish": {
            "0": "Antes de comenzar:",
            "1": "1) Ajusta la ventana de tu buscador a pantalla completa (presiona F11 si usas Windows o Linux o CTRL+CMD+f si usas Mac; Si esto no funciona, en el explorador Chrome haz click en el menu Vista y luego en Pantalla Completa) <br><br>2) Evita posibles distracciones (Televisión, teléfono, etc.) que puedan afectar tu concentración durante la tarea <br><br>3) Colócate a un brazo de distancia de la pantalla del ordenador y trata de mantener esta distancia durante el experimento <br><br>Cuando estés listo, haz click en CONTINUAR.",
            "2": "CONTINUAR",
            "NEXT": "CONTINUAR",
            "FINISH": "FINALIZAR"
        },
        "hebrew": {
            "0": "לפני שנתחיל:",
            "1": "1) נא להעביר את הדפדפן למסך מלא (ניתן לעשות זאת על ידי לחיצה על F11 בווינדוס ולינוקס, או ע'י צירוף המקשים CTRL+CMD+f במחשבי מקינטוש; במקרה הצורך ניתן לפתוח את התפריט בדפדפן כרום ולבחור באפשרות מסך מלא)) <br><br>2) יש לצמצם הפרעות אשר עלולות להפריע בזמן המבחן (טלוויזיה, טלפון וכו').<br><br>3) אנא מקמו עצמכם במרחק של זרוע מהמסך ונסו לשמור על מרחק זה במהלך הניסוי.<br><br>כאשר סיימתם את הנ'ל, לחצו סיום",
            "2": "סיום",
            "NEXT": "הבא",
            "FINISH": "סיום"
        },
        "farsi": {
            "0": "قبل از شروع",
            "1": "۱) مرورگر خود را در حالت تمام صفحه تنظیم کنید (برای اینکار در ویندوز از کلید F11 ودر لینوکس یا مک از کلیدهای CTRL+CMD+f استفاده کنید. اگر این کلیدها کار نکردند در مرورگر کروم به منو view رفته و گزینه Full Screen را انتخاب کنید <br><br>۲) تا حد امکان نرم افزارهای جانبی (مانند تلویزیون، تلفن و غیره) را که باعث افت کارکرد سیستم در طول آزمون می شوند را ببندید.<br><br>۳) در فاصله مناسب (به اندازه فاصله کف دست تا بازو) از مانیتور نشسته و سعی کنید این فاصله را در طول آزمون حفظ کنید. <br><br> بعد از انجام تمام موارد بالا روی دکمه “انجام” کلیک کنید.",
            "2": "انجام",
            "NEXT": "بعدی",
            "FINISH": "پایان دهید"
        },
        "arabic": {
            "0": "قبل البدء,",
            "1": " 1)  اضبط نافذة متصفحك على خيار ملء الشاشة (بإمكانك تفعيل هذا الخيار عن طريق الضغط على F11  في نظام وندوز أو لينكس , أو على الأزرار CTRL + CMD + f  في نظام ماك. إذا لم تعمل هذه الطريقة , في متصفح Chrome  اختر  قائمة العرض  و منها اضغط على خيار ملء الشاشىة(.  احرص على تقليل أي أصوات مشتتة ( مثل التلفاز , التلفون و غيرهم) و التي قد تؤثر على الأداء خلال قيامك بالاختبار. اجلس بحيث تكون على بعد ذراع من الشاشة. بعد إتمامك لهذه التعليمات اضغط على خيار أتممت . ",
            "2": "أتممت,",
            "NEXT": "تالي,",
            "FINISH": "إنهاء"
        },
        "italian": {
            "0": "Prima di iniziare:",
            "1": "1) setta la finestra del tuo browser a Schermo Intero (puoi farlo premendo F11 se usi Windows o Linux, oppure premendo CTRL+CMD+f se usi un  Mac; se questo non funziona, ad esempio su Chrome, puoi andare nel menu Vista e cliccare Schermo Intero)<br><br>2) riduci le possibili distrazioni (es. spegni la TV, cellulare etc.) che potrebbero inficiare la tua prestazione durante il test.<br><br>3) posizionati ad un braccio di distanza dallo schermo e cerca di mantenere questa distanza durante tutto l’esperimento.<br><br> Quando hai fatto clicca Ho Fatto.",
            "2": "Ho Fatto",
            "NEXT": "AVANTI",
            "FINISH": "FINIRE"
        },
        "german": {
            "0": "Bevor Sie beginnen:",
            "1": "1) Stellen Sie Ihr Browser-Fenster auf den Vollbildmodus ein (Sie können hierfür unter Windows und Linux F11 drücken oder auf einem Mac die Tastenkombination CTRL+CMD+f; wenn das nicht funktioniert, können Sie in Chrome zum Menüpunkt „Anzeigen“ gehen und auf „Vollbildmodus“ klicken). <br><br> 2) Minimieren Sie mögliche Ablenkungen (TV, Telefon etc.), die Ihre Leistung während des Tests beeinträchtigen können. <br><br>3) Positionieren Sie sich eine Armlänge vom Monitor entfernt und versuchen Sie, diesen Abstand während des Experiments beizubehalten.<br><br>Wenn Sie damit fertig sind, klicken Sie auf FERTIG.",
            "2": "FERTIG",
            "NEXT": "WEITER",
            "FINISH": "BEENDEN"
        },
        "portuguese": {
            "0": "Antes de começar:",
            "1": "1) Coloque a sua janela de navegação em tela cheia (No Windows ou no Linux pressione F11 e no Mac utilize a combinação de teclas CTRL+CMD+f; Se não funcionar, no Chrome você pode ir ao Zoom do menu e clicar na Tela Cheia)<br><br>2)Reduza possíveis distrações (TV, telemóvel, etc.) que podem afetar a sua performance durante o teste<br><br>3)Esteja à distância de um braço do monitor e mantenha essa posição durante toda a experiência.<br><br>Assim que estiver pronto, clique em FEITO.",
            "2": "FEITO",
            "NEXT": "SEGUINTE",
            "FINISH": "CONCLUIR"
        },
        "turkish": {
            "0": "Başlamadan önce:",
            "1": "1) tarama pencerenizi Tam Ekran olarak ayarlayın (bunu Windows ve Linux'ta F11'e veya Mac'te CTRL +CMD+f tuş kombinasyonuna basarak yapabilirsiniz; bu işe yaramazsa, Chrome'da Görünüm menüsüne gidebilir ve Tam Ekrana Gir'e tıklayabilirsiniz) <br><br>2) test sırasında performansınızı etkileyebilecek olası dikkat dağıtıcı unsurları (TV, telefon vb.) en aza indirin <br><br>3) kendinizi monitörden kol uzunluğu kadar uzakta konumlandırın ve deney boyunca bu izleme mesafesini korumaya çalışın<br><br>Bunlar yapıldığında YAPILDI'yı tıklayın.",
            "2": "YAPILDI",
            "NEXT": "İLERİ",
            "FINISH": "BİTİR"
        },
        "korean": {
            "0": "시작하기 전에:",
            "1": "1) 브라우징 창을 전체 화면으로 설정하세요 (Windows 및 Linux에서는 F11을 누르고, Mac에서는 CTRL+CMD+F를 눌러 설정할 수 있습니다. 이 방법이 작동하지 않는다면, Chrome에서는 보기 메뉴로 가서 \"전체 화면\"을 클릭하세요). <br><br>2) 시험 중 성과에 영향을 줄 수 있는 가능한 방해 요소(텔레비전, 전화 등)를 최소화하세요. <br><br>3) 모니터에서 팔 길이의 거리에 자신을 위치시키고, 실험 중 이 시청 거리를 유지하도록 하세요. <br><br>이 작업이 완료되면, 완료 버튼을 클릭하세요.",
            "2": "완료",
            "NEXT": "다음",
            "FINISH": "완료"
        },
        "vietnamese": {
            "0": "Trước khi bắt đầu:",
            "1": "1) đặt cửa sổ trình duyệt của bạn ở chế độ Toàn Màn Hình (bạn có thể làm điều này bằng cách nhấn phím F11 trên Windows và Linux hoặc tổ hợp phím CTRL+CMD+f trên Mac; nếu không hoạt động, trong Chrome bạn có thể vào menu Xem và nhấp vào Nhập Toàn Màn Hình) <br><br>2) giảm thiểu các yếu tố gây xao nhãng (TV, điện thoại, v.v.) có thể ảnh hưởng đến hiệu suất của bạn trong quá trình kiểm tra <br><br>3) đặt mình ở khoảng cách vừa tầm tay từ màn hình và cố gắng duy trì khoảng cách nhìn này trong suốt quá trình thí nghiệm<br><br>Sau khi hoàn thành các bước này, nhấp vào HOÀN THÀNH.",
            "2": "XONG",
            "NEXT": "TIẾP THEO",
            "FINISH": "HOÀN THÀNH"
        },
        "japanese": {
            "0": "開始する前に：",
            "1": "1) ブラウジングウィンドウをフルスクリーンにする（WindowsとLinuxではF11を、MacではCTRL+CMD+fのキーコンビネーションで実行できます。これがうまくいかない場合は、Chromeの「表示」メニューから「フルスクリーンに入る」をクリックします）。<br><br>2) テスト中のパフォーマンスに影響を与える可能性のある注意力散漫（テレビ、電話など）を最小限に抑える。<br><br>3) モニターから腕の長さほどの距離をとり、実験中はこの距離を保つようにする。<br><br>これらが完了したら、「完了」をクリックしてください。",
            "2": "完了",
            "NEXT": "次へ",
            "FINISH": "完了する"
        }
    },
    "fullscreen": {
        "mandarin": {
            "0": "开始全屏"
        },
        "english": {
            "0": "Start fullscreen"
        },
        "french": {
            "0": "Démarrer en plein écran"
        },
        "dutch": {
            "0": "Start volledig scherm"
        },
        "spanish": {
            "0": "Pantalla completa"
        },
        "hebrew": {
            "0": "הפעל מסך מלא"
        },
        "farsi": {
            "0": "شروع در حالت تمام صفحه"
        },
        "arabic": {
            "0": "بدأ ملء الشاشة”"
        },
        "italian": {
            "0": "Attiva lo Schermo Intero"
        },
        "german": {
            "0": "Vollbildmodus starten"
        },
        "portuguese": {
            "0": "Iniciar tela cheia "
        },
        "turkish": {
            "0": "Tam ekran başlat"
        },
        "korean": {
            "0": "전체 화면 시작"
        },
        "vietnamese": {
            "0": "Bắt đầu toàn màn hình"
        },
        "japanese": {
            "0": "フルスクリーンで起動"
        }
    },
    "calibration": {
        "mandarin": {
            "0": "校准",
            "1": "请使用信用卡或借记卡，将卡的长边放在屏幕上，并与橙色条形线对齐（该卡仅用作标准测量工具，我们不记录/阅读其中的任何信息！)。然后使用键盘上的左箭头和右箭头键收缩或拉伸线条，直到其长度与卡大致相同。然后单击\\确定\\\"。\"",
            "2": "确定"
        },
        "english": {
            "0": "Calibration",
            "1": "To ensure that stimuli and other visual elements in the study are presented at their intended size, it's crucial that you perform the following step. This is a standard screen calibration procedure, that does not involve any data collection from your card or other items. Please find an object that matches the size of a typical credit card, which could be anything from an actual debit or credit card to a driver's license or an ID card. The key is that the object's dimensions are <b>identical</b> to those of a standard credit card.<br/>Place the longer side of your card-sized object against the screen, aligning it with the orange line displayed. Next, use the left and right arrow keys on your keyboard to adjust the length of this orange line until it precisely matches the length of your card-sized item. When done, click the OK button.",
            "2": "OK"
        },
        "french": {
            "0": "Étalonnage",
            "1": "Munissez-vous d’une carte de banque ou de crédit et placez celle-ci dans le sens de la longueur sur la ligne orange. Servez-vous des flèches gauche et droite sur le clavier pour réduire ou allonger la ligne jusqu’à ce que celle-ci ait environ la même longueur que la carte. Puis cliquez OK.",
            "2": "D'accord"
        },
        "dutch": {
            "0": "Afstelling",
            "1": "Neem een bankkaart of een kaart met dezelfde lengte en plaats de lange rand van de kaart tegen het scherm daar waar de oranje lijn staat. Gebruik vervolgens de links- en rechtse pijltoetsen op het toetsenbord om deze oranje lijn te verlengen of verkorten tot deze dezelfde lengte heeft als je kaart. Druk dan op OK.",
            "2": "OK"
        },
        "spanish": {
            "0": "Calibración",
            "1": "Coloca una tarjeta de crédio/débito horizontalmente, justo debajo de la línea naranja. Usa las teclas izquierda y derecho de tu teclado para ajustar el tamaño de la línea al de la tarjeta de crédito. Una vez que has terminado, haz click en OK.",
            "2": "Está bien."
        },
        "hebrew": {
            "0": "קליברציה",
            "1": "קחו בבקשה כרטיס אשראי והצמידו את הצד הארוך יותר שלו למסך, כך שהוא יהיה מיושר לקו הכתום. לאחר מכן השתמשו בחצים ימינה ושמאלה שעל המקלדת בכדי למתוח או לכווץ את הקו הכתום, עד שהוא יהיה ברוחב של כרטיס האשראי.. בסיום לחצו אישור.",
            "2": "אישור"
        },
        "farsi": {
            "0": "تنظیم درجه بندی (کالبراسیون)",
            "1": "لطفا یک کارت مترو یا بانکی بردارید. کارت را از طول جلو صفحه مانیتور و در مقابل خط نارجی بگیرید. سپس با استفاده از دکمه های جهت نمای راست و چپ کیبرد، خط نارجی را به اندازه طول کارت تنظیم کنید. درنهایت وقتی خط نارجی با کارت هم اندازه شد دکمه تایید را کلیک کنید.",
            "2": "تایید"
        },
        "arabic": {
            "0": "المعايرة,",
            "1": "“فضلا خذ أي بطاقة بنك وضع  حافتها الطويلة بمحاذاة الشاشة واضبطها على الشريط البرتقالي. بعدها استخدم السهمين الأعلى و الأسفل على لوحة المفاتيح لتكبير أو تصغير الخط ‘لى أن يصبح طوله تقريبا مماثلا لطول البطاقة, ثم اضغط موافق ",
            "2": "موافق"
        },
        "italian": {
            "0": "Calibrazione",
            "1": "Prendi una tessera sanitaria (perchè ha una lunghezza standard), mettila sullo schermo e allinea il lato lungo con la barra arancione. Dopodiché, utilizza le freccette sinistra e destra sulla tastiera per accorciare o allungare la barra arancione fino a che non sia il più possibile della lunghezza della tessera sanitaria.  Quando hai fatto clicca OK.",
            "2": "OK"
        },
        "german": {
            "0": "Kalibrierung",
            "1": "Bitte nehmen Sie eine Kredit- oder EC-Karte, legen Sie die Karte mit der langen Kante an den Bildschirm und richten Sie sie an dem orangefarbenen Balken aus (die Karte dient nur als Standard-Messinstrument, wir nehmen keine Informationen von ihr auf/lesen sie nicht!) Benutzen Sie dann die linke und rechte Pfeiltaste auf der Tastatur, um die Linie zu verkleinern oder zu verlängern, bis sie ungefähr die gleiche Länge wie die Karte hat. Klicken Sie dann auf OK.",
            "2": "In Ordnung"
        },
        "portuguese": {
            "0": "Calibração ",
            "1": "Por favor, pegue num cartão de crédito/débito, coloque a borda comprida do cartão na tela e alinhe-o com a barra laranja (o cartão é usado apenas como uma ferramenta de medida padrão, não é gravada/lida nenhuma informação do cartão!). De seguida, use as setas esquerda e direita do teclado para encolher ou esticar a barra até que tenha o mesmo comprimento do cartão. Depois, clique em OK.",
            "2": "Ok"
        },
        "turkish": {
            "0": "Kalibrasyon",
            "1": "Lütfen bir öğrenci kartı, yeni kimlik kartı veya toplu taşıma kartı alın ve kartın uzun kenarını ekrana koyun ve turuncu çubukla hizalayın (kart yalnızca standart bir ölçüm aracı olarak kullanılır, uzun kenarın 8.5 cm olması beklenir. Karttan herhangi bir bilgi kaydetmeyiz / okumayız!). Ardından, kartın uzunluğuyla turuncu çubuğun uzunluğu aynı uzunluğa gelene kadar çizgiyi kısaltmak veya uzatmak için klavyedeki sol ve sağ ok tuşlarını kullanın. Ardından Tamam'ı tıklatın.",
            "2": "TAMAM"
        },
        "korean": {
            "0": "보정",
            "1": "Please take a credit or debit card and put the long edge of the card against the screen and line it up with the orange bar (the card is used only as a standard measurement tool, we don't record/read any information from it!). Then use the left and right arrow keys on the keyboard to shrink or stretch the line until it's about the same length as the card. Then click OK.",
            "2": "확인"
        },
        "vietnamese": {
            "0": "Hiệu chuẩn",
            "1": "Please take a credit or debit card and put the long edge of the card against the screen and line it up with the orange bar (the card is used only as a standard measurement tool, we don't record/read any information from it!). Then use the left and right arrow keys on the keyboard to shrink or stretch the line until it's about the same length as the card. Then click OK.",
            "2": "Được rồi"
        },
        "japanese": {
            "0": "キャリブレーション",
            "1": "クレジットカードやデビットカードを手に取り、カードの長辺を画面に当てて、オレンジ色のバーに並べてください（カードは標準的な測定ツールとしてのみ使用され、そこから情報を記録したり読み取ったりすることはありません！）。次に、キーボードの左右の矢印キーを使って、カードとほぼ同じ長さになるまで線を縮めたり伸ばしたりします。そして、「OK」をクリックします。",
            "2": "はい"
        }
    },
    "consent": {
        "mandarin": {
            "0": "向下滚动以同意",
            "1": "同意",
            "2": "不同意",
            "3": "我同意",
            "4": "我不同意",
            "5": "同意书",
            "6": "信息表",
            "7": "您需要在开始研究前回答所有同意事项",
            "8": "感谢您对我们研究的兴趣。由于您未同意实验的所有方面，目前您将无法参与。如果您对研究有任何疑问或想获取更多信息，请通过[插入联系邮箱/电话]联系研究团队。如果您改变主意并希望参与，您可以返回实验链接并再次查看同意书。",
            "9": "我确认我已阅读并理解本研究提供的信息。<br>我明白我的参与是自愿的，并且我可以随时无须理由地退出。<br>我明白我的数据将被保密处理，任何因本研究而产生的出版物将仅报告匿名数据。<br>我明白我的匿名数据可能会用于未来的研究项目或与其他研究人员分享。<br>我年满18岁或以上，并且在法律上有能力给予同意。<br>我同意参与此项研究。",
            "10": "请在此处阅读此信息表：",
            "11": "这里",
        },
        "english": {
            "0": "scroll down to agree",
            "1": "AGREE",
            "2": "DISAGREE",
            "3": "I consent",
            "4": "I do not consent",
            "5": "Consent form",
            "6": "Information sheet",
            "7": "You need to answer all consent items before you can begin the study",
            "8": "Thank you for your interest in our study. As you have not consented to all aspects of the experiment, you will not be able to participate at this time. If you have any questions about the study or would like more information, please contact the research team at [insert contact email/phone]. If you've changed your mind and wish to participate, you may return to the experiment link and review the consent form again.",
            "9": "I confirm that I have read and understood the information provided for this study.<br>I understand that my participation is voluntary and that I am free to withdraw at any time without giving any reason.<br>I understand that my data will be treated confidentially and any publication resulting from this work will report only anonymized data.<br>I understand that my anonymized data may be used for future research projects or shared with other researchers.<br>I am 18 years of age or older and am legally able to give consent.<br>I agree to take part in this study.",
            "10": "Please read the information sheet",
            "11": "HERE",
        },
        "french": {
            "0": "défilez vers le bas pour accepter",
            "1": "ACCEPTER",
            "2": "REFUSER",
            "3": "J’accepte",
            "4": "Je ne consens pas",
            "5": "Formulaire de consentement",
            "6": "Fiche d’information",
            "7": "Vous devez répondre à tous les éléments de consentement avant de pouvoir commencer l’étude",
            "8": "Merci de l'intérêt que vous portez à notre étude. Comme vous n'avez pas consenti à tous les aspects de l'expérience, vous ne pourrez pas y participer pour le moment. Si vous avez des questions concernant l'étude ou si vous souhaitez obtenir plus d'informations, veuillez contacter l'équipe de recherche à l'adresse suivante : [insérer adresse e-mail/téléphone de contact]. Si vous avez changé d'avis et souhaitez participer, vous pouvez revenir au lien de l'expérience et revoir le formulaire de consentement.",
            "9": "Je confirme avoir lu et compris les informations fournies concernant cette étude.<br>Je comprends que ma participation est volontaire et que je suis libre de me retirer à tout moment sans avoir à fournir de justification.<br>Je comprends que mes données seront traitées de manière confidentielle et que toute publication résultant de ce travail ne présentera que des données anonymisées.<br>Je comprends que mes données anonymisées pourront être utilisées pour de futurs projets de recherche ou partagées avec d'autres chercheurs.<br>Je déclare être âgé(e) de 18 ans ou plus et être légalement capable de donner mon consentement.<br>J'accepte de participer à cette étude.",
            "10": "Veuillez lire la fiche d'information",
            "11": "ICI",
        },
        "dutch": {
            "0": "scroll naar beneden om aan te geven dat u akkoord bent",
            "1": "AKKOORD",
            "2": "ONEENS",
            "3": "Ik stem ermee in",
            "4": "Ik geef geen toestemming",
            "5": "Toestemmingsformulier",
            "6": "Informatieblad",
            "7": "U moet alle toestemmingsitems beantwoorden voordat u aan het onderzoek kunt beginnen",
            "8": "Dank u voor uw interesse in ons onderzoek. Omdat u niet met alle aspecten van het experiment heeft ingestemd, kunt u op dit moment niet deelnemen. Als u vragen heeft over het onderzoek of meer informatie wilt, neem dan contact op met het onderzoeksteam via [plaats contact e-mail/telefoonnummer]. Als u van gedachten bent veranderd en toch wilt deelnemen, kunt u terugkeren naar de experimentlink en het toestemmingsformulier opnieuw bekijken.",
            "9": "Ik bevestig dat ik de verstrekte informatie voor dit onderzoek heb gelezen en begrepen.<br>Ik begrijp dat mijn deelname vrijwillig is en dat ik op elk moment zonder opgave van redenen kan stoppen.<br>Ik begrijp dat mijn gegevens vertrouwelijk worden behandeld en dat elke publicatie die uit dit werk voortvloeit alleen geanonimiseerde gegevens zal bevatten.<br>Ik begrijp dat mijn geanonimiseerde gegevens mogelijk worden gebruikt voor toekomstig onderzoek of worden gedeeld met andere onderzoekers.<br>Ik ben 18 jaar of ouder en wettelijk in staat om toestemming te geven.<br>Ik stem ermee in om deel te nemen aan dit onderzoek.",
            "10": "Lees alsjeblieft het informatieblad ",
            "11": "HIER",
        },
        "spanish": {
            "0": "desplaza la pantalla hacia abajo para aceptar",
            "1": "ACEPTO",
            "2": "DESACUERDO",
            "3": "Yo consiento",
            "4": "Yo no consiento",
            "5": "Formulario de consentimiento",
            "6": "Hoja de informacion",
            "7": "Debe responder a todos los elementos de consentimiento antes de poder comenzar el estudio",
            "8": "Gracias por su interés en nuestro estudio. Como no ha dado su consentimiento para todos los aspectos del experimento, no podrá participar en este momento. Si tiene alguna pregunta sobre el estudio o desea más información, por favor póngase en contacto con el equipo de investigación en [inserte correo electrónico/teléfono de contacto]. Si ha cambiado de opinión y desea participar, puede volver al enlace del experimento y revisar el formulario de consentimiento nuevamente.",
            "9": "Confirmo que he leído y comprendido la información proporcionada para este estudio.<br>Entiendo que mi participación es voluntaria y que soy libre de retirarme en cualquier momento sin necesidad de dar ninguna razón.<br>Entiendo que mis datos serán tratados de manera confidencial y cualquier publicación que resulte de este trabajo reportará solo datos anonimizados.<br>Entiendo que mis datos anonimizados pueden ser utilizados para futuros proyectos de investigación o compartidos con otros investigadores.<br>Tengo 18 años o más y tengo la capacidad legal para dar mi consentimiento.<br>Acepto participar en este estudio.",
            "10": "Por favor, lea la hoja de información",
            "11": "AQUÍ",
        },
        "hebrew": {
            "0": "נא לגלול למטה בעזרת העכבר בכדי להסכים",
            "1": "מסכים/ה",
            "2": "אני לא מסכים",
            "3": "אני מסכים",
            "4": "אני לא מסכים",
            "5": "טופס הסכמה",
            "6": "דף מידע",
            "7": "עליך לענות על כל פריטי ההסכמה לפני שתוכל להתחיל במחקר",
            "8": "תודה על התעניינותך במחקר שלנו. מאחר שלא הסכמת לכל ההיבטים של הניסוי, לא תוכל להשתתף בשלב זה. אם יש לך שאלות על המחקר או אם ברצונך לקבל מידע נוסף, אנא צור קשר עם צוות המחקר ב-[הכנס דוא\"ל/טלפון ליצירת קשר]. אם שינית את דעתך וברצונך להשתתף, אתה יכול לחזור לקישור הניסוי ולסקור מחדש את טופס ההסכמה.",
            "9": "אני מאשר שקראתי והבנתי את המידע שניתן עבור מחקר זה.<br>אני מבין שהשתתפותי היא בהתנדבות ושאני חופשי לפרוש בכל עת ללא צורך לתת סיבה.<br>אני מבין שהמידע שלי יטופל באופן סודי וכל פרסום שינבע מעבודה זו ידווח רק על נתונים אנונימיים.<br>אני מבין שהנתונים האנונימיים שלי עשויים לשמש לפרויקטים מחקריים בעתיד או להיות משותפים עם חוקרים אחרים.<br>אני בן 18 שנים או יותר וכשיר מבחינה חוקית לתת הסכמה.<br>אני מסכים להשתתף במחקר זה.",
            "10": "אנא קרא את דף המידע",
            "11": "כאן",
        },
        "farsi": {
            "0": "برای قبول شرایط آزمون، لطفا به انتهای صفحه بروید.",
            "1": "قبول دارم",
            "2": "مخالف بودن",
            "3": "أنا موافق",
            "4": "من رضایت نمی دهم",
            "5": "نموذج الموافقة",
            "6": "ورقة المعلومات",
            "7": "نتحتاج إلى الإجابة على جميع بنود الموافقة قبل أن تتمكن من بدء الدراسة",
            "8": "از توجه شما به مطالعه ما سپاسگزاریم. از آنجا که شما با تمام جنبه‌های آزمایش موافقت نکرده‌اید، در این لحظه نمی‌توانید شرکت کنید. اگر سوالی در مورد مطالعه دارید یا می‌خواهید اطلاعات بیشتری کسب کنید، لطفاً با تیم تحقیقاتی از طریق [ایمیل/تلفن تماس] تماس بگیرید. اگر نظر خود را تغییر داده‌اید و مایل به شرکت هستید، می‌توانید به لینک آزمایش بازگردید و فرم رضایت را دوباره بررسی کنید.",
            "9": "تأیید می‌کنم که اطلاعات ارائه شده برای این مطالعه را خوانده و درک کرده‌ام.<br>می‌دانم که مشارکت من اختیاری است و می‌توانم در هر زمان بدون ارائه دلیل انصراف دهم.<br>می‌دانم که داده‌هایم به صورت محرمانه بررسی می‌شوند و هرگونه انتشار نشأت گرفته از این کار، تنها داده‌های ناشناس را گزارش خواهد کرد.<br>می‌دانم که داده‌های ناشناس من ممکن است برای پروژه‌های تحقیقاتی آینده مورد استفاده قرار گیرد یا با سایر محققان به اشتراک گذاشته شود.<br>من ۱۸ سال یا بزرگتر هستم و به صورت قانونی قادر به دادن رضایت هستم.<br>موافقت می‌کنم که در این مطالعه شرکت کنم.",
            "10": "لطفاً برگه اطلاعات را بخوانید",
            "11": "اینجا",
        },
        "arabic": {
            "0": "انزل لأسفل للموافقة ",
            "1": "أوافق ",
            "2": "مخالف بودن",
            "3": "أنا موافق",
            "4": "من رضایت نمی دهم",
            "5": "نموذج الموافقة",
            "6": "ورقة المعلومات",
            "7": "نتحتاج إلى الإجابة على جميع بنود الموافقة قبل أن تتمكن من بدء الدراسة",
            "8": "شكرًا لاهتمامك بدراستنا. نظرًا لعدم إبداء موافقتك على جميع جوانب التجربة، لن تتمكن من المشاركة في هذا الوقت. إذا كانت لديك أي أسئلة حول الدراسة أو ترغب في الحصول على مزيد من المعلومات، يرجى التواصل مع فريق البحث على [إدراج البريد الإلكتروني/رقم الهاتف]. إذا غيرت رأيك وترغب في المشاركة، يمكنك العودة إلى رابط التجربة ومراجعة استمارة الموافقة مرة أخرى.",
            "9": "أؤكد أنني قد قرأت وفهمت المعلومات المقدمة لهذه الدراسة.<br>أفهم أن مشاركتي طوعية وأنه يمكنني الانسحاب في أي وقت دون إبداء أي سبب.<br>أفهم أن بياناتي ستعامل بسرية وأن أي نشر ينتج عن هذا العمل سيقتصر فقط على البيانات المجهولة.<br>أفهم أن بياناتي المجهولة قد تُستخدم في مشاريع بحثية مستقبلية أو تُشارك مع باحثين آخرين.<br>أنا أبلغ من العمر 18 سنة أو أكثر وأستطيع قانونياً إعطاء الموافقة.<br>أوافق على المشاركة في هذه الدراسة.",
            "10": "يرجى قراءة النشرة الإرشادية ",
            "11": "هنا",
        },
        "italian": {
            "0": "scorri in giù per acconsentire",
            "1": "SI, ACCONSENTO",
            "2": "NON ACCONSENTO",
            "3": "Acconsento",
            "4": "Non acconsento",
            "5": "Modulo di consenso",
            "6": "Foglio informativo",
            "7": "Devi rispondere a tutti gli elementi del consenso prima di poter iniziare lo studio",
            "8": "Grazie per il tuo interesse nel nostro studio. Poiché non hai acconsentito a tutti gli aspetti dell'esperimento, non potrai partecipare in questo momento. Se hai domande sullo studio o desideri ulteriori informazioni, contatta il team di ricerca all'email/numero di telefono fornito. Se hai cambiato idea e desideri partecipare, puoi tornare al link dell'esperimento e rivedere nuovamente il modulo di consenso.",
            "9": "Confermo di aver letto e compreso le informazioni fornite per questo studio.<br>Comprendo che la mia partecipazione è volontaria e che sono libero di ritirarmi in qualsiasi momento senza dover fornire alcuna motivazione.<br>Comprendo che i miei dati saranno trattati in modo confidenziale e che qualsiasi pubblicazione derivante da questo lavoro riporterà solo dati anonimizzati.<br>Comprendo che i miei dati anonimizzati potrebbero essere utilizzati per progetti di ricerca futuri o condivisi con altri ricercatori.<br>Ho 18 anni o più e sono legalmente in grado di dare il consenso.<br>Accetto di partecipare a questo studio.",
            "10": "Si prega di leggere il foglio informativo",
            "11": "QUI",
        },
        "german": {
            "0": "Scrollen Sie nach unten, um zuzustimmen",
            "1": "ZUSTIMMEN",
            "2": "ABLEHNEN",
            "3": "Ich bin einverstanden",
            "4": "Ich bin nicht einverstanden",
            "5": "Einverständniserklärung",
            "6": "Informationsblatt",
            "7": "Sie müssen alle Einwilligungspunkte beantworten, bevor Sie mit der Studie beginnen können",
            "8": "Vielen Dank für Ihr Interesse an unserer Studie. Da Sie nicht allen Aspekten des Experiments zugestimmt haben, können Sie derzeit nicht teilnehmen. Wenn Sie Fragen zur Studie haben oder weitere Informationen wünschen, kontaktieren Sie bitte das Forschungsteam unter [E-Mail/Telefonnummer einfügen]. Falls Sie Ihre Meinung geändert haben und doch teilnehmen möchten, können Sie den Link zum Experiment erneut aufrufen und das Einverständnisformular erneut durchsehen.",
            "9": "Ich bestätige, dass ich die bereitgestellten Informationen zu dieser Studie gelesen und verstanden habe.<br>Ich verstehe, dass meine Teilnahme freiwillig ist und dass ich jederzeit ohne Angabe von Gründen zurücktreten kann.<br>Ich verstehe, dass meine Daten vertraulich behandelt werden und jede Veröffentlichung, die sich aus dieser Arbeit ergibt, nur anonymisierte Daten enthält.<br>Ich verstehe, dass meine anonymisierten Daten für zukünftige Forschungsprojekte verwendet oder mit anderen Forschern geteilt werden können.<br>Ich bin 18 Jahre alt oder älter und rechtlich in der Lage, meine Zustimmung zu geben.<br>Ich erkläre mich bereit, an dieser Studie teilzunehmen.",
            "10": "Bitte lesen Sie hier das Informationsblatt",
            "11": "HIER",
        },
        "portuguese": {
            "0": "Role para baixo para concordar",
            "1": "CONCORDO",
            "2": "DISCORDO",
            "3": "Eu consinto",
            "4": "Eu não consinto",
            "5": "Formulário de consentimento",
            "6": "Folha de Informação",
            "7": "Você precisa responder a todos os itens de consentimento antes de começar o estudo",
            "8": "Obrigado pelo seu interesse em nosso estudo. Como você não consentiu com todos os aspectos do experimento, não poderá participar neste momento. Se tiver alguma dúvida sobre o estudo ou desejar mais informações, entre em contato com a equipe de pesquisa pelo [inserir e-mail/telefone de contato]. Se você mudou de ideia e deseja participar, pode retornar ao link do experimento e revisar o formulário de consentimento novamente.",
            "9": "Confirmo que li e entendi as informações fornecidas para este estudo.<br>Compreendo que minha participação é voluntária e que sou livre para me retirar a qualquer momento, sem necessidade de fornecer justificativa.<br>Entendo que meus dados serão tratados de forma confidencial e que qualquer publicação resultante deste trabalho relatará apenas dados anonimizados.<br>Compreendo que meus dados anonimizados podem ser usados em futuros projetos de pesquisa ou compartilhados com outros pesquisadores.<br>Tenho 18 anos ou mais e estou legalmente apto a dar consentimento.<br>Concordo em participar deste estudo.",
            "10": "Por favor, leia a ficha informativa",
            "11": "AQUI",
        },
        "turkish": {
            "0": "kabul etmek için aşağı kaydırın",
            "1": "KABUL EDİYORUM",
            "2": "KATILMIYORUM",
            "3": "onaylıyorum",
            "4": "Kabul etmiyorum",
            "5": "Rıza formu",
            "6": "Bilgilendirme sayfası",
            "7": "Çalışmaya başlamadan önce tüm onay maddelerini yanıtlamanız gerekir",
            "8": "Çalışmamıza gösterdiğiniz ilgi için teşekkür ederiz. Deneyin tüm aşamalarına onay vermediğiniz için şu an katılamayacaksınız. Çalışma hakkında herhangi bir sorunuz varsa veya daha fazla bilgi almak isterseniz, lütfen araştırma ekibiyle [iletişim e-posta/telefonunu ekleyin] adresinden iletişime geçin. Fikrinizi değiştirdiyseniz ve katılmak istiyorsanız, deney bağlantısına geri dönerek onay formunu tekrar gözden geçirebilirsiniz.",
            "9": "Bu çalışma ile ilgili sağlanan bilgileri okuduğumu ve anladığımı onaylıyorum.<br>Katılımımın gönüllülük esasına dayandığını ve istediğim zaman, herhangi bir neden belirtmeksizin, çalışmadan çekilebileceğimi anlıyorum.<br>Verilerimin gizli tutulacağını ve bu çalışmadan elde edilecek herhangi bir yayının sadece anonimleştirilmiş verileri bildireceğini anlıyorum.<br>Anonimleştirilmiş verilerimin, gelecekteki araştırma projeleri için kullanılabileceğini veya diğer araştırmacılarla paylaşılabileceğini anlıyorum.<br>18 yaşında veya daha büyük olduğumu ve yasal olarak onay vermeye yetkili olduğumu beyan ediyorum.<br>Bu çalışmaya katılmayı kabul ediyorum.",
            "10": "Lütfen bilgi formunu okuyun",
            "11": "BURADA",
        },
        "korean": {
            "0": "동의하려면 아래로 스크롤하십시오.",
            "1": "동의합니다",
            "2": "동의하지 않음",
            "3": "동의합니다",
            "4": "동의하지 않습니다",
            "5": "동의서",
            "6": "정보지",
            "7": "연구를 시작하기 전에 모든 동의 항목에 답변해야 합니다.",
            "8": "저희 연구에 대한 관심에 감사드립니다. 귀하께서 실험의 모든 측면에 동의하지 않으셨으므로 현재로서는 참여하실 수 없습니다. 연구에 대해 질문이 있거나 더 많은 정보를 원하시면 연구팀에 [연락처 이메일/전화번호 삽입]으로 문의해 주시기 바랍니다. 마음이 바뀌어 참여를 원하신다면, 실험 링크로 돌아가 동의서를 다시 검토하실 수 있습니다.",
            "9": "본 연구에 대한 정보를 읽고 이해하였음을 확인합니다.<br>참여가 자발적이며, 언제든지 이유를 제시하지 않고 철회할 수 있음을 이해합니다.<br>제 데이터는 기밀로 처리되며, 이 작업에서 나온 출판물은 익명화된 데이터만 보고할 것임을 이해합니다.<br>제 익명화된 데이터가 향후 연구 프로젝트에 사용되거나 다른 연구자들과 공유될 수 있음을 이해합니다.<br>저는 18세 이상이며, 법적으로 동의할 수 있는 능력이 있음을 확인합니다.<br>본 연구에 참여하는 것에 동의합니다.",
            "10": "여기에서 정보 시트를 읽어 주세요:",
            "11": "여기",
        },
        "vietnamese": {
            "0": "cuộn xuống để đồng ý",
            "1": "ĐỒNG Ý",
            "2": "KHÔNG ĐỒNG Ý",
            "3": "Tôi đồng ý",
            "4": "Tôi không đồng ý",
            "5": "Biểu mẫu đồng ý",
            "6": "Tờ thông tin",
            "7": "Bạn cần trả lời tất cả các mục đồng ý trước khi có thể bắt đầu nghiên cứu.",
            "8": "Cảm ơn bạn đã quan tâm đến nghiên cứu của chúng tôi. Vì bạn chưa đồng ý với tất cả các khía cạnh của thí nghiệm, bạn sẽ không thể tham gia vào lúc này. Nếu bạn có bất kỳ câu hỏi nào về nghiên cứu hoặc muốn biết thêm thông tin, vui lòng liên hệ với nhóm nghiên cứu qua [chèn email/số điện thoại liên lạc]. Nếu bạn đã thay đổi ý định và muốn tham gia, bạn có thể quay lại liên kết thí nghiệm và xem lại đơn đồng ý một lần nữa.",
            "9": "Tôi xác nhận rằng tôi đã đọc và hiểu thông tin được cung cấp cho nghiên cứu này.<br>Tôi hiểu rằng sự tham gia của tôi là tự nguyện và tôi có quyền rút lui bất kỳ lúc nào mà không cần đưa ra lý do.<br>Tôi hiểu rằng dữ liệu của tôi sẽ được xử lý một cách bảo mật và bất kỳ công bố nào từ công việc này sẽ chỉ báo cáo dữ liệu đã được ẩn danh.<br>Tôi hiểu rằng dữ liệu ẩn danh của tôi có thể được sử dụng cho các dự án nghiên cứu trong tương lai hoặc được chia sẻ với các nhà nghiên cứu khác.<br>Tôi từ 18 tuổi trở lên và có quyền hợp pháp để đồng ý tham gia.<br>Tôi đồng ý tham gia vào nghiên cứu này.",
            "10": "Vui lòng đọc bảng thông tin",
            "11": "TẠI ĐÂY",
        },
        "japanese": {
            "0": "同意するためにスクロールダウンする",
            "1": "同意する",
            "2": "同意しない",
            "3": "同意する",
            "4": "同意しない",
            "5": "同意書",
            "6": "情報シート",
            "7": "実験に参加するためには同意書の全ての項目に回答する必要があります",
            "8": "私たちの研究にご関心をお寄せいただき、ありがとうございます。実験のすべての側面に同意されていないため、今回は参加することができません。研究について質問がある場合や、詳細な情報を希望される場合は、研究チームに[連絡先メール/電話番号を挿入してください]までご連絡ください。もしご意向が変わり、参加を希望される場合は、実験のリンクに戻り、もう一度同意書をご確認ください。",
            "9": "この研究に関して提供された情報を読み、その内容を理解したことを確認します。<br>参加は自発的であり、理由を示すことなくいつでも自由に撤退できることを理解しています。<br>私のデータは機密として扱われ、この研究による出版物には匿名化されたデータのみが報告されることを理解しています。<br>私の匿名化されたデータが将来の研究プロジェクトに使用されたり、他の研究者と共有されたりする可能性があることを理解しています。<br>私は18歳以上であり、法的に同意を与えることができます。<br>この研究に参加することに同意します。",
            "10": "情報シートをお読みください",
            "11": "こちら",
        }
    },
    "pdetails": {
        "mandarin": {
            "0": "被试信息",
            "1": "被试ID（例如，Mind ID 或者 MTurk ID）：",
            "2": "年龄：",
            "3": {
                "0": "你的性别是什么？",
                "1": "男",
                "2": "女",
                "3": "其他"
            },
            "4": {
                "0": "最高教育水平：",
                "1": "请选择",
                "2": "低于中学",
                "3": "中学或同等学历",
                "4": "大学或技术学院",
                "5": "学士学位",
                "6": "硕士/博士"
            },
            "5": {
                "0": "利手：",
                "1": "右",
                "2": "左",
                "3": "双利手"
            },
            "6": {
                "0": "你认为自己是：",
                "1": "请选择",
                "2": "异性恋",
                "3": "同性恋",
                "4": "双性恋",
                "5": "其他"
            },
            "7": {
                "0": "种族：",
                "1": "请选择",
                "2": "白种人",
                "3": "西班牙或拉丁裔",
                "4": "黑人或非洲裔美国人",
                "5": "美洲印第安人",
                "6": "亚洲或太平洋岛人",
                "8": "其他"
            },
            "8": "国籍：",
            "9": {
                "0": "名称必须填写",
                "1": "年龄必须填写",
                "2": "年龄必须在18和99岁之间",
                "3": "性别必须填写",
                "4": "教育必须填写",
                "5": "利手必须填写",
                "6": "性取向必须填写",
                "7": "种族必须填写",
                "8": "国籍必须填写",
                "9": "必须填写",
                "10": "出生时分配的性别必须填写"
            },
            "10": "下一步",
            "11": {
                "0": "您出生时指定的性别是什么？",
                "1": "男性",
                "2": "女性"
            }
        },
        "english": {
            "0": "Participant Information",
            "1": "Participant ID (e.g. Mind ID or MTurk ID):",
            "2": "Age:",
            "3": {
                "0": "What is your current gender identity?",
                "1": "Man",
                "2": "Woman",
                "3": "Other"
            },
            "4": {
                "0": "Highest Level of Education:",
                "1": "Please select",
                "2": "less than High school ",
                "3": "High school or equivalent ",
                "4": "College or Technical school",
                "5": "Bachelor degree",
                "6": "Master/Doctorate"
            },
            "5": {
                "0": "Handedness:",
                "1": "Right",
                "2": "Left",
                "3": "Ambidextrous"
            },
            "6": {
                "0": "Do you consider yourself to be:",
                "1": "Please select",
                "2": "Heterosexual or straight",
                "3": "Gay or lesbian",
                "4": "Bisexual",
                "5": "Other"
            },
            "7": {
                "0": "Ethnicity origin:",
                "1": "Please select",
                "2": "White",
                "3": "Hispanic or Latino",
                "4": "Black or African American",
                "5": "Native American or American Indian",
                "6": "Asian / Pacific Islander",
                "7": "South Asian",
                "8": "Other"
            },
            "8": "Nationality:",
            "9": {
                "0": "Id must be filled out",
                "1": "Age must be filled out",
                "2": "Age must be between 18 and 99",
                "3": "Gender must be filled out",
                "4": "Education must be filled out",
                "5": "Handedness must be filled out",
                "6": "Sexual orientation must be filled out",
                "7": "Ethnicity must be filled out",
                "8": "Nationality must be filled out",
                "9": " must be filled out",
                "10": "Sex assigned at birth must be filled out"
            },
            "10": "NEXT",
            "11": {
                "0": "What is the Sex you were assigned at birth?",
                "1": "Male",
                "2": "Female"
            }
        },
        "french": {
            "0": "Information sur le/la participant(e)",
            "1": "Identification (MTurk code, etc.):",
            "2": "Âge :",
            "3": {
                "0": "Quelle est votre identité de genre actuelle ?",
                "1": "Homme",
                "2": "Femme",
                "3": "Autre"
            },
            "4": {
                "0": "Diplôme le plus élevé:",
                "1": "Sélectionnez",
                "2": "Secondaire inférieur",
                "3": "Secondaire supérieur",
                "4": "Bachelier",
                "5": "Master",
                "6": "Doctorat"
            },
            "5": {
                "0": "Droitier/Gaucher:",
                "1": "Droitier",
                "2": "Gaucher",
                "3": "Ambidextre"
            },
            "6": {
                "0": "Vous considérez-vous comme étant :",
                "1": "Sélectionnez",
                "2": "Hétérosexuel(le)",
                "3": "Homosexuel(le)",
                "4": "Bisexuel(le)",
                "5": "Autre"
            },
            "7": {
                "0": "Origine ethnique:",
                "1": "Sélectionnez",
                "2": "Européenne",
                "3": "Nord-africaine",
                "4": "Turque",
                "5": "Africaine",
                "6": "Asiatique",
                "7": "",
                "8": "Autre"
            },
            "8": "Nationalité:",
            "9": {
                "0": "Nom doit être rempli",
                "1": "Age doit être rempli",
                "2": "Age doit se situer entre 18 et 99 ans",
                "3": "Sexe doit être rempli",
                "4": "Diplôme le plus élevé doit être rempli",
                "5": "Droitier/gaucher doit être rempli",
                "6": "Sexual orientation doit être rempli",
                "7": "Origine ethnique doit être rempli",
                "8": "Nationalité doit être rempli",
                "9": " doit être rempli",
                "10": "Le sexe assigné à la naissance doit être renseigné."
            },
            "10": "SUIVANT",
            "11": {
                "0": "Quel est le sexe qui vous a été attribué à la naissance ?",
                "1": "Homme",
                "2": "Femme"
            }
        },
        "dutch": {
            "0": "Informatie over de deelnemer",
            "1": "Identificatiecode (e.g. MTurk ID):",
            "2": "Leeftijd:",
            "3": {
                "0": "Wat is uw huidige genderidentiteit?",
                "1": "Man",
                "2": "Vrouw",
                "3": "Ander"
            },
            "4": {
                "0": "Hoogste scholingsniveau:",
                "1": "Selecteer",
                "2": "Geen diploma secundair onderwijs ",
                "3": "Diploma secundair onderwijs (of gelijkwaardig)",
                "4": "Bachelor",
                "5": "Master",
                "6": "Doctoraat"
            },
            "5": {
                "0": "Handgebruik:",
                "1": "Rechtshandig",
                "2": "Linkshandig",
                "3": "Ambidextrisch"
            },
            "6": {
                "0": "Beschouw je jezelf als:",
                "1": "Selecteer",
                "2": "Heteroseksueel",
                "3": "Homoseksueel of lesbisch",
                "4": "Biseksueel",
                "5": "Overige"
            },
            "7": {
                "0": "Etnische origine:",
                "1": "Selecteer",
                "2": "Europees",
                "3": "Turks",
                "4": "Noord-Afrikaans",
                "5": "Afrikaans (behalve Noord-Afrikaans)",
                "6": "Aziatisch",
                "7": "",
                "8": "Andere"
            },
            "8": "Nationaliteit:",
            "9": {
                "0": "Naam dient ingevuld te worden",
                "1": "Leeftijd dient ingevuld te worden",
                "2": "Leeftijd dient tussen 18 en 99 te zijn",
                "3": "Geslacht dient ingevuld te worden",
                "4": "Scholingsniveau dient ingevuld te worden",
                "5": "Handgebruik dient ingevuld te worden",
                "6": "Sexual orientation dient ingevuld te worden",
                "7": "Etnische origine dient ingevuld te worden",
                "8": "Nationaliteit dient ingevuld te worden",
                "9": " dient ingevuld te worden",
                "10": "Geboorte geslacht moet worden ingevuld"
            },
            "10": "VOLGENDE",
            "11": {
                "0": "Wat is het geslacht dat je bij de geboorte hebt gekregen?",
                "1": "Man",
                "2": "Vrouw"
            }
        },
        "spanish": {
            "0": "Información sobre el participante",
            "1": "Identidad (e.g., Mind ID o Mturk ID):",
            "2": "Edad:",
            "3": {
                "0": "Cuál es su identidad de género actual?",
                "1": "Hombre",
                "2": "Mujer",
                "3": "Otros"
            },
            "4": {
                "0": "Nivel de estudios:",
                "1": "Por favor, elige",
                "2": "Menos de secundaria ",
                "3": "Secundaria o equivalente ",
                "4": "Formación profesional",
                "5": "Diplomado/licenciado/grado",
                "6": "Master/Doctorado"
            },
            "5": {
                "0": "Diestro o zurdo:",
                "1": "Diestro",
                "2": "Zurdo",
                "3": "Ambidiesro"
            },
            "6": {
                "0": "Te consideras:",
                "1": "Por favor, elige",
                "2": "Heterosexual",
                "3": "Gay o lesbiana",
                "4": "Bisexual",
                "5": "Otro"
            },
            "7": {
                "0": "Origen étnico:",
                "1": "Por favor, elige",
                "2": "Blanco",
                "3": "Hispano o latino",
                "4": "Negro",
                "5": "Nativo americano",
                "6": "Asiático",
                "7": "",
                "8": "Otro"
            },
            "8": "Nacionalidad:",
            "9": {
                "0": "El nombre tiene que ser incluido",
                "1": "La edad tiene que ser incluida",
                "2": "La edad tiene que ser entre 18 y 99 años",
                "3": "El género tiene que ser incluido",
                "4": "El nivel de estudios tiene que ser incluido",
                "5": "Diestro o zurdo tiene que ser incluido",
                "6": "La orientación sexual tiene que ser incluida",
                "7": "El origen etnico tiene que ser incluido",
                "8": "La nacionalidad tiene que ser incluida",
                "9": " tiene que ser incluido/a",
                "10": "Sexo asignado al nacer debe ser completado"
            },
            "10": "Siguiente",
            "11": {
                "0": "Cuál es el sexo que le asignaron al nacer?",
                "1": "Masculino",
                "2": "Femenino"
            }
        },
        "hebrew": {
            "0": "פרטים אישיים",
            "1": "מספר מזהה (כגון המספר המזהה ב- MTurk ):",
            "2": "גיל:",
            "3": {
                "0": "מגדר?",
                "1": "גבר",
                "2": "אישה",
                "3": "אחר"
            },
            "4": {
                "0": "רמת השכלה:",
                "1": "נא לבחור",
                "2": "פחות מהשכלה תיכונית",
                "3": "השכלה תיכונית או מקבילה",
                "4": "מכללה או תעודה מקצועית",
                "5": "תואר ראשון",
                "6": "תואר שני/דוקטורט"
            },
            "5": {
                "0": "יד דומיננטית",
                "1": "ימין",
                "2": "שמאל",
                "3": "אמבידקסטרי"
            },
            "6": {
                "0": "האם את/ה רואה עצמך כ:",
                "1": "נא לבחור",
                "2": "הטרוסקסואל/ית או סטרייט/ית",
                "3": "הומוסקסואל או לסבית",
                "4": "בי-סקסואל/ית",
                "5": "אחר"
            },
            "7": {
                "0": "מוצא אתני:",
                "1": "נא לבחור",
                "2": "לבן",
                "3": "היספני או לטיני",
                "4": "שחור או אפריקאי-אמריקאי",
                "5": "אינדיאני",
                "6": "אסייתי / בן האיים הפסיפיים ",
                "7": "",
                "8": "אחר"
            },
            "8": "לאום:",
            "9": {
                "0": "חובה למלא שם",
                "1": "חובה למלא גיל",
                "2": "הגיל חייב להיות בין 18 ל- 99",
                "3": "חובה למלא מגדר",
                "4": "חובה למלא רמת השכלה",
                "5": "חובה למלא יד דומיננטית",
                "6": "חובה למלא אוריינטציה מינית",
                "7": "חובה למלא מוצא אתני",
                "8": "חובה למלא לאום",
                "9": " חובה למלא",
                "10": "יש למלא את המין שנקבע בלידה"
            },
            "10": "הבא",
            "11": {
                "0": "מהו המין שהוקצו לך בלידה?",
                "1": "זָכָר",
                "2": "נְקֵבָה"
            }
        },
        "farsi": {
            "0": "اطلاعات شرکت کننده",
            "1": "کد (مانند کد کاربری آمازون یا کد کاربری شرکت در آزمون):",
            "2": "سن:",
            "3": {
                "0": "جنسیت",
                "1": "مرد",
                "2": "زن",
                "3": "نامشخص"
            },
            "4": {
                "0": "تحصیلات:",
                "1": "لطفا انتخاب کنید",
                "2": "سیکل",
                "3": "دیپلم",
                "4": "کاردانی",
                "5": "لیسانس",
                "6": "فوق لیسانس/دکترا"
            },
            "5": {
                "0": "با کدام دست خود می نویسید:",
                "1": "دست راست",
                "2": "دست چپ",
                "3": "هر دو دست"
            },
            "6": {
                "0": "تمایل جنسی:",
                "1": "لطفا انتخاب کنید",
                "2": "جنس مخالف خود",
                "3": "همجنسگرا",
                "4": "هر دو جنس",
                "5": "دیگر"
            },
            "7": {
                "0": "قومیت و نژاد:",
                "1": "مرکز ایران",
                "2": "شمال ایران",
                "3": "جنوب ایران",
                "4": "شرق ایران",
                "5": "غرب ایران",
                "6": "فارسی زبان غیر ایرانی (افغان، تاجیک و ...)",
                "7": "غیرفارسی زبان",
                "8": "دیگر"
            },
            "8": "ملیت:",
            "9": {
                "0": "وارد کردن اسم الزامی است",
                "1": "وارد کردن سن الزامی است",
                "2": "سن باید بین ۱۸ تا ۹۹ سال باشد",
                "3": "وارد کردن جنسیت الزامی است",
                "4": "وارد کردن تحصیلات الزامی است",
                "5": "وارد کردن وضعیت دست چپ/راست الزامی است",
                "6": "وارد کردن تمایل جنسی الزامی است",
                "7": "وارد کردن قومیت الزامی است",
                "8": "وارد کردن ملیت الزامی است",
                "9": " وارد کردن الزامی است",
                "10": "تعیین جنسیت هنگام تولد باید تکمیل شود"
            },
            "10": "بعدی",
            "11": {
                "0": "جنسیتی که در بدو تولد به شما اختصاص داده شده چیست؟",
                "1": "نر",
                "2": "زن"
            }
        },
        "arabic": {
            "0": "امعلومات المشارك,",
            "1": "رقم التعريف الشخصي,",
            "2": "العمر,",
            "3": {
                "0": "الجنس,",
                "1": "ذكر,",
                "2": "“أنثى,",
                "3": "غير ذلك "
            },
            "4": {
                "0": "أعلى مرحلة علمية,",
                "1": "فضلا اختر,",
                "2": "أقل من الثانوية,",
                "3": "الثانوية العامة أو ما يعادلها ",
                "4": "كلية أو معهد فني,",
                "5": "بكالوريوس,",
                "6": "ماجستير أو دكتواه"
            },
            "5": {
                "0": "اليد التي تستخدمها غالبا,",
                "1": "اليمنى,",
                "2": "اليسرى",
                "3": "ستخدم اليدين بشكل جيد بالتساوي "
            },
            "6": {
                "0": "هل تعتبر نفسك,",
                "1": "فضلا اختر,",
                "2": "جمستقيم,",
                "3": "مثلي  مثلية الجنس ,",
                "4": "ثنائي الجنس",
                "5": "أخرى"
            },
            "7": {
                "0": "العرق,",
                "1": "فضلا اختر,",
                "2": "أبيض,",
                "3": "جلاتيني ,",
                "4": "أسود أو أمريكي أفريقي,",
                "5": "أمريكي هندي,",
                "6": "آسيوي من جزر المحيط الهاديء,",
                "7": "جنوب آسيا",
                "8": "آخر"
            },
            "8": "الجنسية,",
            "9": {
                "0": "يجب أن تعبـأ خانة الاسم,",
                "1": "ويجب أن تعبأ خانة العمر,",
                "2": "العمر يجب أن يكون بين 18 و 99 ,",
                "3": "يجب أن تعبأ خانة الجنس,",
                "4": "يجب أن تعبأ خانة أعلى مرحلة تعليمية,",
                "5": "يجب أن تعبأ خانة اليد المستخدمة غالبا,",
                "6": "يجب أن تعبـأ خانة التوجه الجنسي,",
                "7": "يجب أن تعبأ خانة العرق,",
                "8": "يجب أن تعبأ خانة الجنسية,",
                "9": "يجب أن تعبأ ",
                "10": "يجب ملء خانة الجنس المعين عند الولادة"
            },
            "10": "التالي",
            "11": {
                "0": "ما هو الجنس الذي تم تكليفك به عند الولادة؟",
                "1": "ذكر",
                "2": "أنثى"
            }
        },
        "italian": {
            "0": "Informazioni del partecipante",
            "1": "ID (ad esempio la tua ID Mind o Mturk):",
            "2": "Età:",
            "3": {
                "0": "Qual è la tua attuale identità di genere?",
                "1": "Uomo",
                "2": "Donna",
                "3": "Altro"
            },
            "4": {
                "0": "Livello d’istruzione:",
                "1": "Seleziona",
                "2": "Scuola primaria",
                "3": "Scuola superiore",
                "4": "Laurea triennale",
                "5": "Laurea magistrale",
                "6": "Master/Dottorato"
            },
            "5": {
                "0": "Preferenza manuale:",
                "1": "Destrimane",
                "2": "Mancino",
                "3": "Ambidestro"
            },
            "6": {
                "0": "Ti consideri:",
                "1": "Seleziona",
                "2": "Eterosessuale",
                "3": "Gay o Lesbica",
                "4": "Bisessuale",
                "5": "Altro"
            },
            "7": {
                "0": "Origini etniche:",
                "1": "Seleziona",
                "2": "Bianco",
                "3": "Ispanico o Latino",
                "4": "Nero o Americano di Origini Africane",
                "5": "Nativo Americano o Indio Americano",
                "6": "Asiatico / Isole Pacifiche",
                "7": "",
                "8": "Altro"
            },
            "8": "Nazionalità:",
            "9": {
                "0": "Inserire il nome",
                "1": "Inserire l’età",
                "2": "L’età deve essere tra 18 e 99",
                "3": "Inserire il genere",
                "4": "Inserire il livello d’istruzione",
                "5": "Inserire la preferenza manuale",
                "6": "Inserire l’orientamento sessuale",
                "7": "Inserire le origini etniche",
                "8": "Inserire la nazionalità",
                "9": " deve essere inserito",
                "10": "Il sesso assegnato alla nascita deve essere compilato"
            },
            "10": "AVANTI",
            "11": {
                "0": "Qual è il sesso che ti è stato assegnato alla nascita?",
                "1": "Maschio",
                "2": "Femmina"
            }
        },
        "german": {
            "0": "Teilnehmerinformationen",
            "1": "Teilnehmer-ID (z.B. Mind ID oder MTurk ID):",
            "2": "Alter:",
            "3": {
                "0": "Was ist Ihre aktuelle Geschlechtsidentität?",
                "1": "Mann",
                "2": "Frau",
                "3": "Anderes"
            },
            "4": {
                "0": "Höchster Bildungsabschluss:",
                "1": "Bitte wählen Sie aus",
                "2": "Haupt- oder Realschulabschluss ",
                "3": "Hochschulreife ",
                "4": "Bachelor",
                "5": "Master",
                "6": "Promotion"
            },
            "5": {
                "0": "Händigkeit:",
                "1": "Rechtshändig",
                "2": "Linkshändig",
                "3": "Beidhändig"
            },
            "6": {
                "0": "Sehen Sie sich selbst als:",
                "1": "Bitte wählen Sie aus",
                "2": "Heterosexuell",
                "3": "Homosexuell",
                "4": "Bisexuell",
                "5": "Anderes"
            },
            "7": {
                "0": "Ethnische Herkunft:",
                "1": "Bitte wählen Sie aus",
                "2": "Europäisch",
                "3": "Nordamerikanisch",
                "4": "Südamerikanisch",
                "5": "Afrikanisch",
                "6": "Asiatisch",
                "7": "",
                "8": "Andere"
            },
            "8": "Nationalität:",
            "9": {
                "0": "Name erforderlich",
                "1": "Alter erforderlich",
                "2": "Ihr Alter muss zwischen 18 und 99 Jahren liegen",
                "3": "Geschlecht erforderlich",
                "4": "Bildungsabschluss erforderlich",
                "5": "Händigkeit erforderlich",
                "6": "Sexuelle Orientierung erforderlich",
                "7": "Ethnizität erforderlich",
                "8": "Nationalität erforderlich",
                "9": " erforderlich",
                "10": "Bei Geburt zugewiesenes Geschlecht muss ausgefüllt werden."
            },
            "10": "WEITER",
            "11": {
                "0": "Welches Geschlecht wurde Ihnen bei der Geburt zugewiesen?",
                "1": "Männlich",
                "2": "Weiblich"
            }
        },
        "portuguese": {
            "0": "Informação do Participante ",
            "1": "ID do Participante",
            "2": "Idade",
            "3": {
                "0": "Qual é a sua identidade de gênero atual?",
                "1": "Homem",
                "2": "Mulher",
                "3": "Outro"
            },
            "4": {
                "0": "Escolaridade",
                "1": "Por favor selecione ",
                "2": "Ensino Básico",
                "3": "Ensino Secundário ou equivalente ",
                "4": "Escola Técnica ",
                "5": "Licenciatura ",
                "6": "Mestrado/Doutoramento "
            },
            "5": {
                "0": "Lateralidade",
                "1": "Destro",
                "2": "Canhoto",
                "3": "Ambidestro"
            },
            "6": {
                "0": "Você considera-se ser:",
                "1": "Por favor selecione",
                "2": "Heterossexual",
                "3": "Homossexual",
                "4": "Bissexual ",
                "5": "Outro"
            },
            "7": {
                "0": "Origem Étnica",
                "1": "Por favor selecione ",
                "2": "Branco",
                "3": "Hispânico ou Latino",
                "4": "Negro ou Afro-americano",
                "5": "Nativo Americano ou Índio Americano",
                "6": "Asiático / Ilhéu do Pacífico",
                "7": "",
                "8": "Outro"
            },
            "8": "Nacionalidade",
            "9": {
                "0": "O nome deve ser preenchido ",
                "1": "A idade deve ser preenchida ",
                "2": "A idade deve estar entre os 18 e os 99 anos",
                "3": "O género deve ser preenchido ",
                "4": "A escolaridade deve ser preenchida",
                "5": "A lateralidade deve ser preenchida ",
                "6": "A orientação sexual deve ser preenchida",
                "7": "A etnia deve ser preenchida ",
                "8": "A nacionalidade deve ser preenchida",
                "9": "Deve ser preenchido",
                "10": "Sexo atribuído ao nascimento deve ser preenchido"
            },
            "10": "SEGUINTE",
            "11": {
                "0": "Qual é o sexo que lhe foi atribuído ao nascer?",
                "1": "Masculino",
                "2": "Feminino"
            }
        },
        "turkish": {
            "0": "Katılımcı Bilgileri",
            "1": "Katılımcı Numarası (örn: Mind Numarası veya MTurk Numarası):",
            "2": "Yaş:",
            "3": {
                "0": "Şu anki cinsiyet kimliğiniz nedir?",
                "1": "Erkek",
                "2": "Kadın",
                "3": "Diğer"
            },
            "4": {
                "0": "En Son Mezun Olduğunuz Eğitim Seviyesi:",
                "1": "Lütfen seçiniz",
                "2": "lise seviyesinin altı ",
                "3": "Lise ",
                "4": "Ön Lisans",
                "5": "Lisans",
                "6": "Yüksek Lisans/Doktora"
            },
            "5": {
                "0": "Baskın El:",
                "1": "Sağ",
                "2": "Sol",
                "3": "Her iki el"
            },
            "6": {
                "0": "Kendinizi nasıl tanımlıyorsunuz:",
                "1": "Lütfen seçiniz",
                "2": "Heteroseksüel",
                "3": "Gay/Eşcinsel veya lezbiyen",
                "4": "Biseksüel",
                "5": "Diğer"
            },
            "7": {
                "0": "Etnik köken:",
                "1": "Lütfen seçiniz",
                "2": "Beyaz",
                "3": "İspanyol veya Latin",
                "4": "Siyahi veya Afrikan Amerikalı",
                "5": "Yerli Amerikalı veya Kızılderili",
                "6": "Asyalı / Pasifik Adalı",
                "7": "",
                "8": "Diğer"
            },
            "8": "Milliyet:",
            "9": {
                "0": "İsim doldurulmalıdır",
                "1": "Yaş doldurulmalıdır",
                "2": "Yaş 18 ile 99 arasında olmalıdır",
                "3": "Cinsiyet doldurulmalıdır",
                "4": "Eğitim doldurulmalıdır",
                "5": "Baskın el doldurulmalıdır",
                "6": "Cinsel yönelim doldurulmalıdır",
                "7": "Etnik köken doldurulmalıdır",
                "8": "Milliyet doldurulmalıdır",
                "9": " doldurulmalıdır",
                "10": "Doğumda atanan cinsiyet doldurulmalıdır."
            },
            "10": "İLERİ",
            "11": {
                "0": "Doğumda size atanan Cinsiyet nedir?",
                "1": "Erkek",
                "2": "Kadın"
            }
        },
        "korean": {
            "0": "참가자 정보",
            "1": "참가자 ID(예: Mind ID 또는 MTurk ID):",
            "2": "나이:",
            "3": {
                "0": "현재의 성 정체성은 무엇입니까?",
                "1": "남성",
                "2": "여성",
                "3": "다른"
            },
            "4": {
                "0": "최고 수준의 교육:",
                "1": "선택하십시오",
                "2": "고등학교 이하",
                "3": "고등학교 또는 이에 상응하는",
                "4": "대학 또는 기술 학교",
                "5": "학사 학위",
                "6": "석사/박사"
            },
            "5": {
                "0": "손재주:",
                "1": "오른쪽",
                "2": "왼쪽",
                "3": "양손 잡이의"
            },
            "6": {
                "0": "자신을 생각합니까:",
                "1": "선택 해주세요",
                "2": "이성애자",
                "3": "게이 또는 레즈비언",
                "4": "양성애자",
                "5": "다른"
            },
            "7": {
                "0": "민족적 기원:",
                "1": "선택 해주세요",
                "2": "백인",
                "3": "히스패닉 또는 라티노",
                "4": "흑인 또는 아프리카계 미국인",
                "5": "아메리카 원주민 또는 아메리칸 인디언",
                "6": "아시아인 / 태평양 섬 주민",
                "7": "남아시아",
                "8": "다른"
            },
            "8": "국적:",
            "9": {
                "0": "아이디는 반드시 기입하셔야 합니다",
                "1": "나이를 입력해야 합니다.",
                "2": "연령은 18세에서 99세 사이여야 합니다.",
                "3": "성별을 입력해야 합니다.",
                "4": "교육을 작성해야 합니다.",
                "5": "잘 쓰는 손  반드시 기입해야 합니다",
                "6": "성적 취향을 작성해야 합니다",
                "7": "민족을 입력해야 합니다",
                "8": "국적을 반드시 기재해야 합니다",
                "9": " 작성해야합니다",
                "10": "출생 시 지정된 성별을 기입해야 합니다"
            },
            "10": "다음",
            "11": {
                "0": "출생 시 지정된 성별은 무엇입니까?",
                "1": "남성",
                "2": "여성"
            }
        },
        "vietnamese": {
            "0": "Thông tin người tham gia",
            "1": "ID người tham gia (ví dụ: Mind ID hoặc MTurk ID):",
            "2": "tuổi:",
            "3": {
                "0": "Bản sắc giới tính hiện tại của bạn là gì?",
                "1": "Người đàn ông",
                "2": "Phụ nữ",
                "3": "Khác"
            },
            "4": {
                "0": "Trình độ học vấn cao nhất:",
                "1": "Vui lòng chọn",
                "2": "Dưới trung học",
                "3": "Trường trung học hoặc tương đương",
                "4": "Cao đẳng hoặc trường kỹ thuật",
                "5": "Bằng cử nhân",
                "6": "Thạc sĩ / Tiến sĩ"
            },
            "5": {
                "0": "thuận tay:",
                "1": "Phải",
                "2": "Bên trái",
                "3": "Thuận cả hai tay"
            },
            "6": {
                "0": "Bạn có coi mình là:",
                "1": "Vui lòng chọn",
                "2": "dị tính",
                "3": "đồng tính nam hay đồng tính nữ?",
                "4": "lưỡng tính",
                "5": "Khác"
            },
            "7": {
                "0": "Nguồn gốc dân tộc:",
                "1": "Vui lòng chọn",
                "2": "Trắng",
                "3": "Tây Ban Nha hoặc Latino",
                "4": "Da đen hoặc người Mỹ gốc Phi",
                "5": "Người Mỹ bản địa hoặc người Mỹ bản địa",
                "6": "Châu Á / Thái Bình Dương",
                "7": "phía nam Châu Á",
                "8": "Khác"
            },
            "8": "Quốc tịch:",
            "9": {
                "0": "Id phải được điền vào",
                "1": "Tuổi phải được điền",
                "2": "Tuổi phải từ 18 đến 99",
                "3": "Giới tính phải được điền",
                "4": "Giáo dục phải được điền vào",
                "5": "thuận tay phải được điền vào",
                "6": "Xu hướng tình dục phải được điền vào",
                "7": "Dân tộc phải được điền",
                "8": "Quốc tịch phải được điền",
                "9": " phải được điền vào",
                "10": "Phải điền giới tính khi sinh"
            },
            "10": "KẾ TIẾP",
            "11": {
                "0": "Giới tính bạn được chỉ định khi sinh là gì?",
                "1": "Nam giới",
                "2": "Nữ giới"
            }
        },
        "japanese": {
            "0": "参加者情報",
            "1": "参加者ID (例：Mind ID や MTurk ID):",
            "2": "年齢：",
            "3": {
                "0": "現在のジェンダーアイデンティティは？",
                "1": "男性",
                "2": "女性",
                "3": "その他"
            },
            "4": {
                "0": "最終学歴：",
                "1": "選択してください",
                "2": "中学校・小学校　",
                "3": "高校もしくはそれ同等　",
                "4": "大学もしくは専門学校",
                "5": "学士号",
                "6": "修士・博士課程"
            },
            "5": {
                "0": "利き手：",
                "1": "右",
                "2": "左",
                "3": "両手利き"
            },
            "6": {
                "0": "あなたが自認しているのは：",
                "1": "選択してください",
                "2": "ヘテロセクシャルもしくはストレート",
                "3": "ゲイ・レズビアン",
                "4": "バイセクシュアル",
                "5": "その他"
            },
            "7": {
                "0": "人種：",
                "1": "選択してください",
                "2": "白人",
                "3": "ヒスパニックもしくはラティーノ",
                "4": "黒人もしくはアフリカ系アメリカ人",
                "5": "アメリカ先住民もしくはアメリカインディアン",
                "6": "アジア人・太平洋諸島民",
                "7": "南アジア人",
                "8": "その他"
            },
            "8": "国籍：",
            "9": {
                "0": "IDは必ず記入してください",
                "1": "年齢は必ず記入してください",
                "2": "年齢は18-99歳の間である必要があります",
                "3": "ジェンダーは必ず記入してください",
                "4": "学歴は必ず記入してください",
                "5": "利き手は必ず記入してください",
                "6": "性的指向は必ず記入してください",
                "7": "人種は必ず記入してください",
                "8": "国籍は必ず記入してください",
                "9": "　必ず記入してください",
                "10": "出生時に割り当てられた性別は必ず記入してください"
            },
            "10": "次へ",
            "11": {
                "0": "出生時に割り当てられた性別はなんですか？",
                "1": "男性",
                "2": "女性"
            }
        }
    },
    "end": {
        "mandarin": {
            "0": "",
            "1": "太棒了！您完成了实验！谢谢您的参与。<br> <br>要退出全屏，在Windows或者Linux上请按（F11）；在Mac上，请按 CTRL + CMD + f 组合键。",
            "2": "平均分数：",
            "3": "完成此实验的确认码是：",
            "4": "要查看更多信息，请点击这里",
            "5": "为了确认您的参与，请把下面的完成链接复制粘贴到您的浏览器："
        },
        "english": {
            "0": "",
            "1": "Great job! You're done! Thank you for your participation. <br><br> To exit full screen, press 'ESC' on your keyboard.",
            "2": "Average correct score: ",
            "3": "The confirmation code for completing this experiment is: ",
            "4": "To see more information, click here.",
            "5": "To confirm your participation, please use the following completion link by copying and pasting into your browser:"
        },
        "french": {
            "0": "",
            "1": "Fantastique ! Vous avez terminé ! Merci beaucoup pour votre participation.<br><br>Pour quitter le mode plein écran, pressez 'ESC' sur ton clavier.",
            "2": "Score de réussite moyen: ",
            "3": "Le code de confirmation qui indique que vous avez terminé ce test est: ",
            "4": "Pour voir plus d'informations, cliquez ici.",
            "5": "Pour confirmer votre participation, veuillez utiliser le lien de complétion suivant en le copiant et collant dans votre navigateur :"
        },
        "dutch": {
            "0": "",
            "1": "Goed gedaan! Je hebt het experiment afgelegd! Bedankt voor je deelname.<br><br>Om de weergave op volledig scherm af te sluiten dien je 'ESC' på dit tastatur.",
            "2": "Gemiddelde score: ",
            "3": "De confirmatiecode die aangeeft dat u de test volledig hebt afgelegd is: ",
            "4": "Klik hier om meer informatie te zien.",
            "5": "Om uw deelname te bevestigen, gebruikt u de volgende voltooiingslink door deze te kopiëren en in uw browser te plakken:"
        },
        "spanish": {
            "0": "",
            "1": "Bien hecho! El studio ha terminado! Muchas gracias por participar. <br><br> Para salir de la pantalla completa, presiona 'ESC' en tu teclado.",
            "2": "Promedio de respuestas correctas: ",
            "3": "El Código de confirmación de este estudio es: ",
            "4": "Para más información, click aquí.",
            "5": "Para confirmar su participación, por favor utilice el siguiente enlace de finalización copiándolo y pegándolo en su navegador:"
        },
        "hebrew": {
            "0": "",
            "1": "מצויין! סיימת! תודה על השתתפותך. <br><br> בכדי לצאת ממסך מלא, נא ללחוץ F11 בווינדוס ולינוקס, או הצירוף CTRL+CMD+F במקינטוש.",
            "2": "ממוצע התשובות הנכונות:",
            "3": "קוד האישור עבור השלמת הניסוי הוא:",
            "4": "כדי לראות מידע נוסף, לחץ כאן.",
            "5": "כדי לאשר את השתתפותך, אנא השתמש בקישור ההשלמה הבא על ידי העתקה והדבקה בדפדפן שלך:"
        },
        "farsi": {
            "0": "",
            "1": "خسته نباشید! شما به پایان آزمون رسیدید. از اینکه در آزمون ما شرکت کردید از شما سپاسگزاریم. <br><br> برای خروج از حالت تمام صفحه، در ویندوز دکمه F11 و در لینوکس یا مک دکمه های CTRL+CMD+f را بزنید.",
            "2": "میانگین جواب های درست: ",
            "3": "کد تایید شما برای تکمیل آزمون: ",
            "4": "برای دیدن اطلاعات بیشتر، اینجا را کلیک کنید.",
            "5": "برای تأیید شرکت خود، لطفاً لینک تکمیل زیر را با کپی و وارد کردن در مرورگر خود استفاده کنید:"
        },
        "arabic": {
            "0": "",
            "1": "عمل جيد ! لقد انتهيث ! شكرا لمشاركتك . للخروج من وضع ملء الشاشة اضغط على F11  إذا كنت تستخدم نظام وندوز و لينكس. على نظام ماك , اضغط على الأزرار الثلاثة   CTRL + CMD + f  مجتمعة ,",
            "2": "معدل الإجابات الصحيحة: ,",
            "3": "للحصول على المزيد من المعلومات , اضغط هنا.,",
            "4": "لتأكيد مشاركتك , فضلا استخدم رابط الإكمال التالي عن طريق نسخه و لصقه في متصفحك",
            "5": "لتأكيد مشاركتك، يرجى استخدام رابط الإكمال التالي عن طريق نسخه ولصقه في متصفحك:"
        },
        "italian": {
            "0": "",
            "1": "Ottimo! Hai finito! Grazie per aver partecipato. <br><br> Per uscire dalla modalità schermo intero, premi 'ESC' sulla tua tastiera.",
            "2": "Media delle risposte corrette: ",
            "3": "Il codice di conferma per aver completato questo esperimento è: ",
            "4": "Per avere più informazioni, clicca qui.",
            "5": "Per confermare la tua partecipazione, copia ed incolla il seguente link sul tuo browser:"
        },
        "german": {
            "0": "",
            "1": "Toll gemacht! Sie sind fertig! Vielen Dank für Ihre Teilnahme. <br><br> Um den Vollbildmodus zu verlassen, drücken Sie auf Ihrer Tastatur 'ESC'.",
            "2": "Durchschnittlich korrekte Punktzahl: ",
            "3": "Der Bestätigungscode, um das Experiment zu beenden, lautet: ",
            "4": "Für weitere Informationen, klicken Sie hier.",
            "5": "Um Ihre Teilnahme zu bestätigen, benutzen Sie bitte den folgenden Bestätigungslink. Kopieren Sie diesen und fügen ihn in Ihrem Browser ein:"
        },
        "portuguese": {
            "0": "",
            "1": "Bom trabalho! Você acabou! Obrigada pela sua participação. <br><br> Para sair da tela cheia, pressione 'ESC' no seu teclado.",
            "2": "Pontuação correta média",
            "3": "O código de confirmação para completar a experiência é",
            "4": "Para ver mais informação, clique aqui.",
            "5": "Para confirmar a sua participação, por favor use o seguinte link de conclusão, copiando e colando no seu navegador:"
        },
        "turkish": {
            "0": "",
            "1": "Eline sağlık! Tamamladın! Katılımınız için teşekkürler. <br> <br> Tam ekrandan çıkmak için klavyenizde 'ESC' tuşuna basın.",
            "2": "Ortalama doğru yanıt: ",
            "3": "Bu deneyi tamamladığınıza dair onay kodu: ",
            "4": "Daha fazla bilgi edinmek için burayı tıklayınız.",
            "5": "Katılımınızı onaylamak için lütfen aşağıdaki tamamlama bağlantısını kopyalayıp tarayıcınıza yapıştırarak kullanın:"
        },
        "vietnamese": {
            "0": "",
            "1": "Làm tốt lắm! Bạn đã hoàn thành! Cảm ơn bạn đã tham gia. <br><br> Để thoát khỏi chế độ toàn màn hình, hãy nhấn 'ESC' trên bàn phím của bạn.",
            "2": "Điểm trung bình đúng:",
            "3": "Mã xác nhận để hoàn thành thí nghiệm này là:",
            "4": "Để xem thêm thông tin, hãy nhấp vào đây.",
            "5": "Để xác nhận sự tham gia của bạn, vui lòng sử dụng đường liên kết hoàn thành sau đây bằng cách sao chép và dán vào trình duyệt của bạn:"
        },
        "korean": {
            "0": "",
            "1": "잘 하셨습니다! 완료되었습니다! 참여해 주셔서 감사합니다. <br><br> 전체 화면을 종료하려면 키보드의 'ESC' 키를 누르세요.",
            "2": "평균 정답 점수:",
            "3": "이 실험을 완료하기 위한 확인 코드는 다음과 같습니다:",
            "4": "더 많은 정보를 보려면 여기를 클릭하세요.",
            "5": "참여를 확인하려면, 아래 완료 링크를 복사하여 브라우저에 붙여넣어 사용해 주십시오:"
        },
        "japanese": {
            "0": "",
            "1": "お疲れ様でした！全て完了しました。参加していただき、ありがとうございます。<br><br> フルスクリーンを解除するには’ESC’キーを押してください。",
            "2": "平均正反応スコア: ",
            "3": "本実験を完了するための確認コード： ",
            "4": "詳細については、こちらをクリックしてください。",
            "5": "参加確認のため、以下の完了リンクをブラウザにコピー＆ペーストしてご利用ください："
        }
    },
    "warnings": {
        "mandarin": {
            "resolution": "对不起，您的屏幕分辨率太低，无法运行此测试，请使用更高分辨率的屏幕再试一次！",
            "firefox": "请使用其他浏览器访问实验。目前这个平台不支持Firefox，您将无法完成实验",
            "ie": "我们不支持Internet Explorer. 请使用更新的浏览器。还有很多其他可选择的浏览器！",
            "mobile": "这个实验并非设计为在平板电脑或手机上运作，请用电脑来运行实验！",
            "localstorage": "实验不能在隐私或隐身模式下运行。"
        },
        "english": {
            "resolution": "Sorry, your screen resolution is too low to run this test. Please try again using a screen with a higher resolution!",
            "firefox": "Please access the experiment using a different browser. Firefox is currently not supported and you won't be able to complete the experiment",
            "ie": "We don't support Internet Explorer. Try with a newer browser, plenty of options out there!",
            "mobile": "This experiment is not designed to work on tablets or mobiles. Please access it from a computer!",
            "localstorage": "Experiment cannot run in Private/Incognito Mode."
        },
        "french": {
            "resolution": "Désolé, votre résolution d’écran est trop basse pour réaliser ce test. Veuillez essayer d’utiliser un écran ayant une plus grande résolution!",
            "firefox": "S’il-vous-plaît, veuillez accéder à l’expérience depuis un navigateur différent. Firefox n’est pour le moment pas supporté et vous ne pourrez pas terminer l’expérience",
            "ie": "Nous ne prenons pas en charge Internet Explorer. Essayez avec un navigateur plus récent, il y a plein d'options disponibles !",
            "mobile": "Cette expérience n’est pas conçue pour fonctionner sur les tablettes ou mobiles. Veuillez y accéder depuis un ordinateur!",
            "localstorage": "L'expérience ne peut pas fonctionner en mode privé/incognito."
        },
        "dutch": {
            "resolution": "Sorry, de beeld resolutie is te laag om de test af te leggen. Probeert u het alstublieft opnieuw via een scherm met een hogere resolutie!",
            "firefox": "Probeert u alstublieft het experiment te starten via een andere browser. Firefox wordt momenteel niet ondersteund en het is dus niet mogelijk de test via deze browser te vervolledigen",
            "ie": "We ondersteunen Internet Explorer niet. Probeer een nieuwere browser, er zijn genoeg opties!",
            "mobile": "Deze test kan niet afgelegd worden via tablets en smartphones. Probeert u alstublieft het experiment te starten via een computer!",
            "localstorage": "Het experiment kan niet worden uitgevoerd in de privé/incognito modus."
        },
        "spanish": {
            "resolution": "Lo sentimos, pero la resolucion de tu pantalla es demasiado pequeña para esta tarea. Por favor, inténtalo de nuevo usando una resolución más alta",
            "firefox": "Probeert u alstublieft het experiment te starten via een andere browser. Firefox wordt momenteel niet ondersteund en het is dus niet mogelijk de test via deze browser te vervolledigen",
            "ie": "No admitimos Internet Explorer. ¡Prueba con un navegador más reciente, hay muchas opciones disponibles!",
            "mobile": "Este estudio no está diseñado para ser realizado desde un móvil o tableta. Por favor, inténtalo de nuevo usando un ordenador!",
            "localstorage": "El experimento no se puede ejecutar en modo privado/incógnito."
        },
        "hebrew": {
            "resolution": "אנו מתנצלים, רזולוציית המסך נמוכה מדי בכדי להריץ את המבחן. אנא נסו שנית עם מסך בעל רזולוציה גבוהה יותר.",
            "firefox": "אנא גלשו לניסוי בעזרת דפדפן אחר. פיירפוקס אינו נתמך כרגע ולא תוכלו לבצע באמצעותו את הניסוי",
            "ie": "איננו תומכים באינטרנט אקספלורר. נסה לדפדפן עדכני יותר, יש הרבה אפשרויות זמינות!",
            "mobile": "ניסוי זה אינו מיועד לרוץ על טאבלט או טלפון נייד. אנא בצעו את הניסוי באמצעות מחשב!",
            "localstorage": "הניסוי לא יכול לפעול במצב פרטי/אנונימי."
        },
        "farsi": {
            "resolution": "کیفیت تصویر: متاسفانه کیفیت تصویر شما برای اجرای این آزمون بسیار پایین می باشد. لطفا یکبار دیگر با صفحه نمایشگری با کیفیت بالاتر امتحان کنید!",
            "firefox": "لطفاً از یک مرورگر دیگر برای دسترسی به آزمایش استفاده کنید. فعلاً مرورگر فایرفاکس پشتیبانی نمی‌شود و نمی‌توانید آزمایش را تکمیل کنید.",
            "ie": "ما از اینترنت اکسپلورر پشتیبانی نمی‌کنیم. با یک مرورگر جدیدتر امتحان کنید، گزینه‌های زیادی موجود است!",
            "mobile": "یا لپتاپ امتحان کنید تلفن همراه: این آزمون برای اجرا در تلفن همراه یا تبلت طراحی نشده است. لطفا با استفاده از کامپیوتر شخصی!",
            "localstorage": "آزمایش نمی‌تواند در حالت خصوصی/ناشناس اجرا شود."
        },
        "arabic": {
            "resolution": "  عفوا , دقة الشاشة منخفضة جدا لأداء هذا الاختبار. فضلا حاول مرة أخرى باستخدام دقة أعلى ",
            "firefox": "يرجى الوصول إلى التجربة باستخدام متصفح مختلف. حالياً، لا يدعم فايرفوكس ولن تتمكن من إكمال التجربة.",
            "ie": "نحن لا ندعم إنترنت إكسبلورر. جرب متصفحًا أحدث، هناك الكثير من الخيارات المتاحة!",
            "mobile": "ی هذه التجربة ليست مصممة للعمل على الجوال أو الأجهزة اللوحية. فضلا استخدم جهاز الكمبيوتر ",
            "localstorage": "لا يمكن تشغيل التجربة في وضع الخصوصية/التصفح الخفي."
        },
        "italian": {
            "resolution": "La risoluzione del tuo schermo è troppo bassa per questo test. Per favore prova ad utilizzare uno schermo con una risoluzione maggiore!",
            "firefox": "Per favore utilizza un browser differente. Firefox non e' attualmente supportato e non potrai completare l'esperimento.",
            "ie": "Internet Explorer non e' supportato. Prova ad utilizzare un altro browser.",
            "mobile": "Questo esperimento non funziona su tablet o cellulari. Per favore completalo utilizzando un computer.",
            "localstorage": "L'esperimento non puo' girare in modalità Privata/Incognita."
        },
        "german": {
            "resolution": "Es tut uns leid, Ihre Bildschirmauflösung ist für diesen Test zu niedrig. Bitte versuchen Sie es erneut mit einem Bildschirm mit einer höheren Auflösung!",
            "firefox": "Bitte öffnen Sie das Experiment in einem anderen Browser. Firefox wird derzeit nicht unterstützt und Sie können das Experiment nicht vollständig durchführen",
            "ie": "Internet Explorer wird von uns nicht unterstützt. Versuchen Sie es mit einem neueren Browser. Es gibt viele Optionen!",
            "mobile": "Dieses Experiment ist nicht für Tablets oder Handys ausgelegt. Bitte nutzen Sie einen Computer!",
            "localstorage": "Das Experiment kann nicht im Privat-/Inkognito-Modus durchgeführt werden."
        },
        "portuguese": {
            "resolution": "Desculpe, a sua resolução de tela é muito baixa para executar o teste. Por favor tente novamente numa tela com maior resolução!",
            "firefox": "Por favor aceda à experiência através de um navegador diferente. De momento, o Firefox não é compatível e você não conseguirá completar a experiência.",
            "ie": "Nós não somos compatíveis com a Internet Explorer. Tente com um navegador mais recente, existem várias opções disponíveis!",
            "mobile": "Esta experiência não foi desenvolvida para ser realizada em tablets ou telemóveis. Por favor aceda através de um computador!",
            "localstorage": "A experiência não pode ser executada no modo privado/anónimo."
        },
        "turkish": {
            "resolution": "Üzgünüz, ekran çözünürlüğünüz bu testi çalıştırmak için çok düşük. Lütfen ekranınızı daha yüksek çözünürlükte kullanarak tekrar deneyin!",
            "firefox": "Lütfen deneye farklı bir tarayıcı kullanarak erişin. Firefox şu anda desteklenmiyor ve deneyi tamamlayamayacaksınız",
            "ie": "Internet Explorer'ı desteklemiyoruz. Daha yeni bir tarayıcıyla deneyin, birçok tarayıcı seçeneği var!",
            "mobile": "Bu deney tabletlerde veya cep telefonlarında çalışmak üzere tasarlanmamıştır. Lütfen bir bilgisayardan erişin!",
            "localstorage": "Deney, Özel / Gizli Modda çalıştırılamaz."
        },
        "korean": {
            "resolution": "죄송합니다. 화면 해상도가 너무 낮아 이 테스트를 실행할 수 없습니다. 더 높은 해상도의 화면을 사용하여 다시 시도해 주세요!",
            "firefox": "실험에 접속하기 위해 다른 브라우저를 사용해 주세요. 현재 Firefox는 지원되지 않으므로 실험을 완료할 수 없습니다.",
            "ie": "저희는 인터넷 익스플로러를 지원하지 않습니다. 더 최신 브라우저를 사용해 보세요. 다양한 옵션이 있습니다!",
            "mobile": "이 실험은 태블릿이나 모바일 기기에서는 작동하지 않도록 설계되었습니다. 컴퓨터에서 접속해 주세요!",
            "localstorage": "실험은 개인/시크릿 모드에서 실행할 수 없습니다."
        },
        "vietnamese": {
            "resolution": "Xin lỗi, độ phân giải màn hình của bạn quá thấp để chạy bài kiểm tra này. Vui lòng thử lại bằng cách sử dụng một màn hình có độ phân giải cao hơn!",
            "firefox": "Vui lòng truy cập thí nghiệm bằng trình duyệt khác. Hiện tại Firefox không được hỗ trợ và bạn sẽ không thể hoàn thành thí nghiệm.",
            "ie": "Chúng tôi không hỗ trợ Internet Explorer. Hãy thử với một trình duyệt mới hơn, có rất nhiều lựa chọn khác ngoài kia!",
            "mobile": "Thí nghiệm này không được thiết kế để hoạt động trên máy tính bảng hoặc điện thoại di động. Vui lòng truy cập từ máy tính!",
            "localstorage": "Thí nghiệm không thể chạy trong Chế độ Riêng tư/Ẩn danh."
        },
        "japanese": {
            "resolution": "申し訳ありませんが、このテストを実行するには画面の解像度が低すぎます。より高い解像度のスクリーンを使用して再度お試しください!",
            "firefox": "別のブラウザで実験にアクセスしてください。Firefoxは現在サポートされていませんので、実験を完了することはできません",
            "ie": "Internet Explorerはサポートされていません。新しいブラウザで試してみてください!",
            "mobile": "この実験は、タブレットや携帯電話では動作しないように設計されています。パソコンからアクセスしてください!",
            "localstorage": "プライベートモード/インコグニートモードでは、実験を行うことができません。"
        }
    },
    "loader": {
        "english": {
            "start": "Uploading results file...",
            "uploading": "% of data uploaded... please wait",
            "success": "Data saved.",
            "failure": "Data transfer failed."
        },
        "mandarin": {
            "start": "正在上传结果文件...",
            "uploading": "% 的数据已被上传... 请等待",
            "success": "数据已保存。",
            "failure": "数据传输失败。"
        },
        "french": {
            "start": "Téléchargement du fichier de résultats...",
            "uploading": "% des données téléchargées... veuillez patienter",
            "success": "Données sauvegardées.",
            "failure": "Échec du transfert de données."
        },
        "dutch": {
            "start": "Bestand met resultaten uploaden...",
            "uploading": "% van gegevens geüpload... even geduld alstublieft",
            "success": "Gegevens opgeslagen.",
            "failure": "Gegevensoverdracht mislukt."
        },
        "spanish": {
            "start": "Cargando archivo de resultados...",
            "uploading": "% de datos cargados... por favor, espere",
            "success": "Datos guardados.",
            "failure": "Fallo en la transferencia de datos."
        },
        "hebrew": {
            "start": "מעלה קובץ תוצאות...",
            "uploading": "% מהנתונים הועלו... נא להמתין",
            "success": "הנתונים נשמרו.",
            "failure": "העברת הנתונים נכשלה."
        },
        "farsi": {
            "start": "در حال بارگذاری فایل نتایج...",
            "uploading": "درصد داده‌های بارگذاری شده... لطفاً صبر کنید",
            "success": "داده‌ها ذخیره شد.",
            "failure": "انتقال داده‌ها ناموفق بود."
        },
        "arabic": {
            "start": "جارٍ تحميل ملف النتائج...",
            "uploading": "٪ من البيانات تم تحميلها... الرجاء الانتظار",
            "success": "تم حفظ البيانات.",
            "failure": "فشل نقل البيانات."
        },
        "italian": {
            "start": "Aggiornamento dei risultati...",
            "uploading": "% dei dati caricata... attendi per favore",
            "success": "Dati salvati.",
            "failure": "Trasferimento dati fallito."
        },
        "german": {
            "start": "Ergebnisdatei hochladen…",
            "uploading": "% der Daten sind hochgeladen… bitte warten Sie",
            "success": "Daten gespeichert.",
            "failure": "Datenübertragung fehlgeschlagen."
        },
        "portuguese": {
            "start": "A carregar o arquivo de resultados…",
            "uploading": "% de dados carregados… Por favor espere",
            "success": "Dados salvos.",
            "failure": "A transferência de dados falhou."
        },
        "turkish": {
            "start": "Sonuçlar dosyası yükleniyor ...",
            "uploading": "Yüzde % veri yüklendi... lütfen bekleyin",
            "success": "Veri kaydedildi.",
            "failure": "Veri aktarımı başarısız oldu."
        },
        "korean": {
            "start": "결과 파일 업로드 중...",
            "uploading": "데이터 업로드 중... 기다려 주세요.",
            "success": "데이터가 저장되었습니다.",
            "failure": "데이터 전송 실패."
        },
        "vietnamese": {
            "start": "Đang tải tệp kết quả lên...",
            "uploading": "% dữ liệu đã tải lên... vui lòng chờ",
            "success": "Dữ liệu đã được lưu.",
            "failure": "Chuyển dữ liệu thất bại."
        },
        "japanese": {
            "start": "結果ファイルをアップロード中…",
            "uploading": "％のデータがアップロード完了…しばらくお待ちください",
            "success": "データ保存完了。",
            "failure": "データ転送失敗。"
        }
    },
    "uploadError": {
        "english": {
            "retryNow": "You may retry to upload the data:",
            "retryLater": "If you want to retry uploading the data at a later time you may do so by accessing the following link:",
            "retryButton": "Retry Upload"
        },
        "mandarin": {
            "retryNow": "您可以尝试重新上传数据:",
            "retryLater": "如果您打算之后重新上传数据，可以通过下面的链接完成：",
            "retryButton": "重试上传"
        },
        "french": {
            "retryNow": "Vous pouvez réessayer de télécharger les données :",
            "retryLater": "Si vous souhaitez réessayer de télécharger les données ultérieurement, vous pouvez le faire en accédant au lien suivant :",
            "retryButton": "Réessayer le Téléchargement"
        },
        "dutch": {
            "retryNow": "U kunt proberen de gegevens opnieuw te uploaden:",
            "retryLater": "Als je de gegevens op een later tijdstip opnieuw wilt uploaden, kun je dat doen via de volgende link:",
            "retryButton": "Opnieuw Uploaden"
        },
        "spanish": {
            "retryNow": "Puede intentar volver a cargar los datos:",
            "retryLater": "Si deseas volver a intentar subir los datos en otro momento, puedes hacerlo accediendo al siguiente enlace:",
            "retryButton": "Reintentar Subir"
        },
        "hebrew": {
            "retryNow": "תוכל לנסות להעלות מחדש את הנתונים:",
            "retryLater": "אם ברצונך לנסות להעלות את הנתונים בשלב מאוחר יותר, תוכל לעשות זאת על ידי גישה לקישור הבא:",
            "retryButton": "נסה להעלות שוב"
        },
        "farsi": {
            "retryNow": "می‌توانید دوباره تلاش کنید داده‌ها را بارگذاری کنید:",
            "retryLater": "اگر می‌خواهید بارگذاری داده‌ها را در زمانی دیگر امتحان کنید، می‌توانید با دسترسی به لینک زیر این کار را انجام دهید:",
            "retryButton": "آپلود مجدد را امتحان کنید"
        },
        "arabic": {
            "retryNow": "يمكنك محاولة إعادة تحميل البيانات:",
            "retryLater": "إذا كنت ترغب في إعادة محاولة تحميل البيانات في وقت لاحق، يمكنك القيام بذلك من خلال الوصول إلى الرابط التالي:",
            "retryButton": "إعادة تحميل"
        },
        "italian": {
            "retryNow": "Puoi riprovare a caricare i dati:",
            "retryLater": "Se vuoi riprovare a caricare i dati in un altro momento, utilizza il seguente link:",
            "retryButton": "Riprova a caricare"
        },
        "german": {
            "retryNow": "Sie können versuchen, die Daten erneut hochzuladen:",
            "retryLater": "Wenn Sie das Hochladen der Daten zu einem späteren Zeitpunkt erneut versuchen möchten, können Sie dies über den folgenden Link tun:",
            "retryButton": "Upload erneut versuchen"
        },
        "portuguese": {
            "retryNow": "Você pode tentar carregar os dados novamente:",
            "retryLater": "Se você quiser repetir o carregamento dos dados mais tarde, você poderá faze-lo acedendo ao seguinte link:",
            "retryButton": "Carregar novamente "
        },
        "turkish": {
            "retryNow": "Verileri yeniden yüklemeyi deneyebilirsiniz:",
            "retryLater": "Verileri daha sonra yeniden yüklemeyi denemek isterseniz, aşağıdaki bağlantıya erişerek bunu yapabilirsiniz:",
            "retryButton": "Yüklemeyi Yeniden Dene"
        },
        "korean": {
            "retryNow": "데이터를 다시 업로드할 수 있습니다:",
            "retryLater": "나중에 데이터를 다시 업로드하려면 다음 링크에 접속하여 시도할 수 있습니다:",
            "retryButton": "업로드 재시도"
        },
        "vietnamese": {
            "retryNow": "Bạn có thể thử tải lại dữ liệu:",
            "retryLater": "Nếu bạn muốn thử lại việc tải dữ liệu lên vào một thời điểm sau, bạn có thể làm như vậy bằng cách truy cập vào liên kết sau:",
            "retryButton": "Thử tải lên lại"
        },
        "japanese": {
            "retryNow": "データのアップロードを再試行することができます：",
            "retryLater": "後日、データのアップロードを再試行したい場合は、以下のリンクにアクセスすることで再試行できます：",
            "retryButton": "アップロードを再試行する"
        }
    },
    "refreshRate": {
        "english": {
            "averageFramerate": "Your average frame rate is: ",
            "recordedFramerate": "Frame rate recorded.",
            "currentFramerate": "Your current frame rate is: ",
            "remainingTime": " more seconds until frame rate recording ends."
        },
        "mandarin": {
            "averageFramerate": "您的平均帧率是：",
            "recordedFramerate": "帧率已记录。",
            "currentFramerate": "您现在的帧率是：",
            "remainingTime": "等待帧率记录结束。"
        },
        "french": {
            "averageFramerate": "Votre fréquence d'images moyenne est :",
            "recordedFramerate": "Taux de trames enregistré.",
            "currentFramerate": "Votre taux de rafraîchissement actuel est :",
            "remainingTime": "plus que quelques secondes avant la fin de l'enregistrement du taux de rafraîchissement."
        },
        "dutch": {
            "averageFramerate": "Je gemiddelde framesnelheid is: ",
            "recordedFramerate": "Framerate vastgelegd.",
            "currentFramerate": "Je huidige framesnelheid is:",
            "remainingTime": "nog enkele seconden totdat de opnames van de framesnelheid eindigen."
        },
        "spanish": {
            "averageFramerate": "Tu tasa de cuadros promedio es:",
            "recordedFramerate": "Tasa de fotogramas registrada.",
            "currentFramerate": "Tu tasa de fotogramas actual es:",
            "remainingTime": "quedan más segundos hasta que termine la grabación de la tasa de fotogramas."
        },
        "hebrew": {
            "averageFramerate": "קצב הפריימים הממוצע שלך הוא:",
            "recordedFramerate": "קצב מסגרת נרשם.",
            "currentFramerate": "קצב הפריימים הנוכחי שלך הוא:",
            "remainingTime": "עוד שניות עד לסיום הקלטת קצב הפריימים."
        },
        "farsi": {
            "averageFramerate": "نرخ فریم متوسط شما عبارت است از:",
            "recordedFramerate": "نرخ فریم ثبت شد.",
            "currentFramerate": "نرخ فریم کنونی شما:",
            "remainingTime": "چند ثانیه بیشتر تا پایان ضبط نرخ فریم باقی مانده است."
        },
        "arabic": {
            "averageFramerate": "معدل الإطارات المتوسط لديك هو:",
            "recordedFramerate": "تم تسجيل معدل الإطارات.",
            "currentFramerate": "معدل الإطارات الحالي لديك هو:",
            "remainingTime": "ثوانٍ معدودة حتى ينتهي تسجيل معدل الإطارات."
        },
        "italian": {
            "averageFramerate": "Il tuo frame rate medio e':",
            "recordedFramerate": "Frame rate registrato.",
            "currentFramerate": "Il tuo frame rate attuale e':",
            "remainingTime": "secondi prima della fine della registrazione del frame rate."
        },
        "german": {
            "averageFramerate": "Ihre durchschnittliche Bildfrequenz beträgt: ",
            "recordedFramerate": "Bildfrequenz aufgezeichnet.",
            "currentFramerate": "Ihre aktuelle Bildfrequenz beträgt: ",
            "remainingTime": " Sekunden bis zum Abschluss der Bildfrequenzaufzeichnung."
        },
        "portuguese": {
            "averageFramerate": "A sua média de frame rate é:",
            "recordedFramerate": "Gravada a frame rate:",
            "currentFramerate": "A sua atual frame rate é: ",
            "remainingTime": "Mais alguns segundo até ao final da gravação da frame rate."
        },
        "turkish": {
            "averageFramerate": "Ortalama ekran saniyelik görüntü sayınız/kare hızınız: ",
            "recordedFramerate": "Saniyelik görüntü sayısı/kare hızı kaydedildi.",
            "currentFramerate": "Anlık ekran saniyelik görüntü sayınız/kare hızınız: ",
            "remainingTime": " kare hızı kayıt bitimine kadar birkaç saniye daha."
        },
        "korean": {
            "averageFramerate": "당신의 평균 프레임 속도는:",
            "recordedFramerate": "프레임 속도 기록됨.",
            "currentFramerate": "현재 프레임 속도는:",
            "remainingTime": "프레임 속도 기록이 끝날 때까지 몇 초 더 남았습니다."
        },
        "vietnamese": {
            "averageFramerate": "Tốc độ khung hình trung bình của bạn là:",
            "recordedFramerate": "Tốc độ khung hình đã được ghi lại.",
            "currentFramerate": "Tốc độ khung hiện tại của bạn là:",
            "remainingTime": "vài giây nữa cho đến khi ghi tốc độ khung hình kết thúc."
        },
        "japanese": {
            "averageFramerate": "あなたの平均フレームレート：　",
            "recordedFramerate": "フレームレートを記録。",
            "currentFramerate": "あなたの現在のフレームレート：　",
            "remainingTime": "　フレームレート記録が終了するまで（秒）。"
        }
    },
    "subject_pool_redirect": {
        "mandarin": {
            "0": "您将会在几秒后被重新导向。",
            "1": "秒。",
            "2": "如果不是，您必须",
            "3": "点击这里完成。",
            "4": "这项研究。",
            "5": "否则您的数据将不会被记录下来。"
        },
        "english": {
            "0": "You should be redirected in",
            "1": "seconds.",
            "2": "If not, YOU MUST",
            "3": "CLICK HERE TO COMPLETE",
            "4": "this study.",
            "5": "Otherwise, your participation won't be recorded"
        },
        "french": {
            "0": "Vous devriez être redirigé dans",
            "1": "secondes.",
            "2": "Sinon, VOUS DEVEZ",
            "3": "CLIQUEZ ICI POUR COMPLÉTER",
            "4": "cette étude.",
            "5": "Sinon, votre participation ne sera pas enregistrée."
        },
        "dutch": {
            "0": "Je zou doorgestuurd moeten worden in",
            "1": "seconden.",
            "2": "Zo niet, MOET U",
            "3": "KLIK HIER OM TE VOLTOOIEN",
            "4": "deze studie.",
            "5": "Anders wordt je deelname niet geregistreerd."
        },
        "spanish": {
            "0": "Serás redirigido en",
            "1": "segundos.",
            "2": "Si no, DEBES",
            "3": "HAZ CLIC AQUÍ PARA COMPLETAR",
            "4": "este estudio.",
            "5": "De lo contrario, tu participación no será registrada."
        },
        "hebrew": {
            "0": "עליך להיות מנותב תוך",
            "1": "שניות.",
            "2": "אם לא, עליך",
            "3": "לחץ כאן להשלמה",
            "4": "מחקר זה.",
            "5": "אחרת, השתתפותך לא תירשם."
        },
        "farsi": {
            "0": "شما باید منتقل شوید در",
            "1": "ثانیه‌ها",
            "2": "در غیر این صورت، شما باید",
            "3": "اینجا کلیک کنید تا تکمیل شود",
            "4": "این مطالعه.",
            "5": "در غیر این صورت، مشارکت شما ثبت نخواهد شد."
        },
        "arabic": {
            "0": "يجب أن يتم إعادة توجيهك خلال",
            "1": "ثوانٍ.",
            "2": "إذا لم يكن كذلك، يجب عليك",
            "3": "انقر هنا لإكمال",
            "4": "هذه الدراسة.",
            "5": "وإلا، فلن يتم تسجيل مشاركتك."
        },
        "italian": {
            "0": "Verrai rindirizzato in",
            "1": "secondi.",
            "2": "Se no, DEVI",
            "3": "CLICCARE QUI PER COMPLETARE",
            "4": "questo studio.",
            "5": "Altrimenti la tua partecipazione non verrà registrata"
        },
        "german": {
            "0": "Sie werden weitergeleitet in",
            "1": "Sekunden.",
            "2": "Falls nicht, MÜSSEN SIE",
            "3": "HIER KLICKEN ZUM FORTFAHREN",
            "4": "dieser Studie.",
            "5": "Andernfalls wird Ihre Teilnahme nicht erfasst"
        },
        "portuguese": {
            "0": "Você deve ser redirecionado em:",
            "1": "segundos.",
            "2": "Se não, VOCÊ DEVE",
            "3": "CLIQUE AQUI PARA COMPLETAR",
            "4": "este estudo.",
            "5": "Caso contrário, a sua participação não será gravada "
        },
        "turkish": {
            "0": "içinde yönlendiriliyor olmalısınız.",
            "1": "saniye",
            "2": "Aksi taktirde,",
            "3": "TAMAMLAMAK İÇİN TIKLAYINIZ.",
            "4": "bu çalışma.",
            "5": "Başka türlü katılımınız kaydedilmez"
        },
        "korean": {
            "0": "곧 리다이렉트됩니다.",
            "1": "초.",
            "2": "그렇지 않으면, 반드시 해야 합니다.",
            "3": "완료하려면 여기를 클릭하십시오",
            "4": "이 연구.",
            "5": "그렇지 않으면 귀하의 참여가 기록되지 않습니다."
        },
        "vietnamese": {
            "0": "Bạn sẽ được chuyển hướng trong vài giây",
            "1": "giây.",
            "2": "Nếu không, BẠN PHẢI",
            "3": "NHẤP VÀO ĐÂY ĐỂ HOÀN TẤT",
            "4": "nghiên cứu này.",
            "5": "Nếu không, sự tham gia của bạn sẽ không được ghi nhận."
        },
        "japanese": {
            "0": "リダイレクトされます",
            "1": "秒。",
            "2": "そうでなければ，必ず",
            "3": "完了するためには、ここを押す",
            "4": "本実験。",
            "5": "そうでなければ、参加は記録されません"
        }
    },
    "enableMediaAutoPlay": {
        "mandarin": {
            "0": "运行这个实验需要媒体自动播放功能 <br> 点击下面使用这个功能。",
            "1": "使用"
        },
        "english": {
            "0": "Media autoplay is required for this experiment to work. <br> Click below to enable it.",
            "1": "Enable"
        },
        "french": {
            "0": "La lecture automatique des médias est requise pour que cette expérience fonctionne. <br> Cliquez ci-dessous pour l'activer.",
            "1": "Activer"
        },
        "dutch": {
            "0": "Automatisch afspelen van media is vereist om dit experiment te laten functioneren. <br> Klik hieronder om het in te schakelen.",
            "1": "Inschakelen"
        },
        "spanish": {
            "0": "Se requiere la reproducción automática de medios para que este experimento funcione. <br> Haz clic a continuación para activarla.",
            "1": "Habilitar"
        },
        "hebrew": {
            "0": "נדרש הפעלת מדיה אוטומטית על מנת שהניסוי יעבוד. <br> לחצו מטה כדי לאפשר זאת.",
            "1": "אפשר"
        },
        "farsi": {
            "0": "پخش خودکار رسانه برای اجرای این آزمایش ضروری است. <br> برای فعال‌سازی، روی دکمه زیر کلیک کنید.",
            "1": "فعال کردن"
        },
        "arabic": {
            "0": "يتطلب هذا التجربة تشغيل الوسائط تلقائيًا لتعمل. <br> اضغط أدناه لتمكينها. ",
            "1": "تمكين"
        },
        "italian": {
            "0": "Questo esperimento necessita di Media autoplay. <br> Clicca sotto per abilitarlo.",
            "1": "Abilita"
        },
        "german": {
            "0": "Damit das Experiment funktioniert, ist eine automatische Medienwiedergabe erforderlich. <br> Klicken Sie unten, um diese zu aktivieren.",
            "1": "Aktivieren"
        },
        "portuguese": {
            "0": "A reprodução automática da media é necessária para que esta experiência funcione. <br> Clique abaixo para permitir.",
            "1": "Habilitar/permitir "
        },
        "turkish": {
            "0": "Bu deneyin çalışması için medyayı otomatik oynatma (Media autoplay) gereklidir. <br> Etkinleştirmek için aşağıyı tıklayın.",
            "1": "Etkinleştir"
        },
        "korean": {
            "0": "이 실험이 작동하려면 미디어 자동 재생이 필요합니다. <br> 아래를 클릭하여 활성화하세요.",
            "1": "사용 가능하게 설정"
        },
        "vietnamese": {
            "0": "Phương tiện tự động phát là cần thiết để thí nghiệm này hoạt động. <br> Nhấp vào bên dưới để bật nó.",
            "1": "Kích hoạt"
        },
        "japanese": {
            "0": "本実験を行うには、メディア自動再生が必要です。下記をクリックして有効にしてください。",
            "1": "許可する"
        }
    },
    "password": {
        "english": {
            "0": "Please enter the password:"
        },
        "italian": {
            "0": "Inserisci la password:"
        },
        "german": {
            "0": "Bitte Passwort eingeben:"
        },
        "portuguese": {
            "0": "Por favor introduza a palavra-passe:"
        },
        "turkish": {
            "0": "Lütfen şifreyi giriniz:"
        },
        "mandarin": {
            "0": "请输入密码："
        },
        "korean": {
            "0": "비밀번호를 입력하세요:"
        },
        "vietnamese": {
            "0": "Vui lòng nhập mật khẩu:"
        },
        "japanese": {
            "0": "パスワードを入力してください："
        },
        "arabic": {
            "0": "يرجى إدخال كلمة المرور:"
        },
        "dutch": {
            "0": "Voer het wachtwoord in:"
        },
        "farsi": {
            "0": "لطفاً رمز عبور را وارد کنید:"
        },
        "french": {
            "0": "Veuillez entrer le mot de passe :"
        },
        "hebrew": {
            "0": "אנא הכנס את הסיסמה:"
        },
        "spanish": {
            "0": "Por favor, introduce la contraseña:"
        }
    },
    "mic": {
        "english": {
            "Allow mic access": "Allow mic access.",
            "Mic is not available": "Mic is not available. The experiment cannot continue.",
            "Calibration required": "Calibration required.",
            "Read out loud these sentences": "<b>Read out loud these sentences:</b> <br>There's nothing you can do that can't be done<br>Nothing you can sing that can't be sung<br>Nothing you can say but you can learn how to play the game<br>It's easy<br>Calibration will end in ",
            "seconds": " seconds",
            "We could not detect your voice": "We could not detect your voice.",
            "Please increase your mic volume": "Please increase your mic volume and refresh the page to try again.",
            "Calibration completed": "Calibration completed.",
            "The experiment will start shortly": "The experiment will start shortly.",
            "uploaded please wait": "% uploaded... please wait",
            "Uploading experiment recording": "Uploading experiment recording",
            "recording-title": "Response recording started.",
            "recording-ends": "Recording ends in:",

        },
        "mandarin": {
            "Allow mic access": "授予麦克风使用权。",
            "Mic is not available": "麦克风不可用。实验无法继续。",
            "Calibration required": "需要校准。",
            "Read out loud these sentences": "<b>请大声读出这些句子：</b> <br>没有什么事是你做不到的<br>没有什么歌是你唱不出的<br>没有什么话是你说不了的<br>但你要学会游戏的规则<br>这很简单<br>校准将在几秒钟后结束。",
            "seconds": "秒",
            "We could not detect your voice": "我们无法探测到您的声音。",
            "Please increase your mic volume": "轻调大您的麦克风的音量，然后刷新网页重试。",
            "Calibration completed": "校准完成。",
            "The experiment will start shortly": "实验马上开始。",
            "uploaded please wait": "%已上传...请等待",
            "Uploading experiment recording": "正在上传实验记录。",
            "recording-title": "录音已开始。",
            "recording-ends": "录音将在以下时间结束：",
        },
        "korean": {
            "Allow mic access": "마이크 접근을 허용하세요.",
            "Mic is not available": "마이크를 사용할 수 없습니다. 실험을 계속 진행할 수 없습니다.",
            "Calibration required": "보정이 필요합니다.",
            "Read out loud these sentences": "<b>이 문장을 큰 소리로 읽으세요:</b> <br>당신이 할 수 없는 것을 할 방법은 없습니다<br>당신이 부를 수 없는 노래는 없습니다<br>당신이 할 수 있는 말은 없지만 게임을 하는 법을 배울 수 있습니다<br>쉽습니다<br>보정은 다음에서 끝납니다",
            "seconds": "초",
            "We could not detect your voice": "당신의 음성을 감지할 수 없습니다.",
            "Please increase your mic volume": "마이크 볼륨을 올리고 페이지를 새로 고침하여 다시 시도해 주세요.",
            "Calibration completed": "보정 완료.",
            "The experiment will start shortly": "실험이 곧 시작될 예정입니다.",
            "uploaded please wait": "% 업로드 중... 잠시 기다려 주세요",
            "Uploading experiment recording": "실험 녹화 업로드"
        },
        "vietnamese": {
            "Allow mic access": "Cho phép truy cập mic.",
            "Mic is not available": "Micro không khả dụng. Thí nghiệm không thể tiếp tục.",
            "Calibration required": "Cần hiệu chuẩn.",
            "Read out loud these sentences": "<b>Đọc to những câu sau:</b> <br>Không có gì bạn có thể làm mà không thể hoàn thành<br>Không có gì bạn có thể hát mà không thể hát được<br>Không có gì bạn có thể nói nhưng bạn có thể học cách tham gia trò chơi<br>Thật dễ dàng<br>Hiệu chuẩn sẽ kết thúc trong",
            "seconds": "giây",
            "We could not detect your voice": "Chúng tôi không thể phát hiện giọng nói của bạn.",
            "Please increase your mic volume": "Vui lòng tăng âm lượng micro của bạn và làm mới trang để thử lại.",
            "Calibration completed": "Hiệu chuẩn đã hoàn tất.",
            "The experiment will start shortly": "Thí nghiệm sẽ bắt đầu sớm.",
            "uploaded please wait": "% đang tải lên... vui lòng chờ",
            "Uploading experiment recording": "Tải lên bản ghi thí nghiệm"
        },
        "japanese": {
            "Allow mic access": "マイクのアクセスを許可する。",
            "Mic is not available": "マイクが使用できません。実験を続行することができません。",
            "Calibration required": "キャリブレーション必須。",
            "Read out loud these sentences": "これらの文章を声に出して読んでください。:</b> <br>There’s nothing you can do that can’t be done<br>Nothing you can sing that can’t be sung<br>Nothing you can say but you can learn how to play the game<br>It’s easy<br>キャリブレーションが終了します ",
            "seconds": "　秒",
            "We could not detect your voice": "声を認識することができません。",
            "Please increase your mic volume": "マイクの音量を大きくし、ページを更新して再度お試しください。",
            "Calibration completed": "キャリブレーション完了。",
            "The experiment will start shortly": "まもなく実験開始します。",
            "uploaded please wait": "％アップロード完了…しばらくお待ちください",
            "Uploading experiment recording": "実験記録をアップロード中"
        },
        "arabic": {
            "Allow mic access": "السماح بالوصول إلى الميكروفون.",
            "Mic is not available": "الميكروفون غير متوفر. لا يمكن أن يستمر التجربة.",
            "Calibration required": "يتطلب المعايرة.",
            "Read out loud these sentences": "<b>اقرأ بصوت عالٍ هذه الجمل:</b> <br>ليس هناك شيء يمكنك القيام به لا يمكن أن يتم<br>ليس هناك شيء يمكنك غناؤه لا يمكن أن يُغنَّى<br>ليس هناك شيء يمكنك قوله ولكن يمكنك تعلم كيفية لعب اللعبة<br>إنه سهل<br>ستُنهي المعايرة في",
            "seconds": "ثوانٍ",
            "We could not detect your voice": "لم نتمكن من اكتشاف صوتك.",
            "Please increase your mic volume": "يرجى زيادة مستوى صوت الميكروفون وتحديث الصفحة للمحاولة مرة أخرى.",
            "Calibration completed": "اكتملت المعايرة.",
            "The experiment will start shortly": "سيبدأ التجربة قريباً.",
            "uploaded please wait": "% جاري التحميل... يرجى الانتظار",
            "Uploading experiment recording": "تحميل تسجيل التجربة"
        },
        "dutch": {
            "Allow mic access": "Toegang tot microfoon toestaan.",
            "Mic is not available": "Microfoon is niet beschikbaar. Het experiment kan niet doorgaan.",
            "Calibration required": "Kalibratie vereist.",
            "Read out loud these sentences": "<b>Lees deze zinnen hardop voor:</b> <br>Er is niets wat je kunt doen dat niet gedaan kan worden<br>Niets wat je kunt zingen dat niet gezongen kan worden<br>Niets wat je kunt zeggen maar je kunt leren hoe je het spel speelt<br>Het is gemakkelijk<br>Kalibratie eindigt over",
            "seconds": "seconden",
            "We could not detect your voice": "We konden uw stem niet detecteren.",
            "Please increase your mic volume": "Verhoog uw microfoonvolume en vernieuw de pagina om het opnieuw te proberen.",
            "Calibration completed": "Kalibratie voltooid.",
            "The experiment will start shortly": "Het experiment begint binnenkort.",
            "uploaded please wait": "% geüpload... even geduld aub",
            "Uploading experiment recording": "Experimentopname uploaden"
        },
        "farsi": {
            "Allow mic access": "اجازه دسترسی به میکروفون را بدهید.",
            "Mic is not available": "میکروفون در دسترس نیست. آزمایش نمی‌تواند ادامه پیدا کند.",
            "Calibration required": "نیاز به کالیبراسیون است.",
            "Read out loud these sentences": "<b>این جملات را با صدای بلند بخوانید:</b> <br>هیچ کاری که نتوان انجام داد نیست<br>هیچ چیزی که نتوان خواند نیست<br>هیچ چیزی نیست که بگویی ولی می‌توانی یاد بگیری که چطور بازی را انجام دهی<br>آسان است<br>تنظیم کالیبراسیون پایان خواهد یافت در ",
            "seconds": "ثانیه‌ها",
            "We could not detect your voice": "ما نتوانستیم صدای شما را شناسایی کنیم.",
            "Please increase your mic volume": "لطفاً میزان صدای میکروفون خود را افزایش دهید و صفحه را مجدداً بارگذاری کنید تا دوباره تلاش کنید.",
            "Calibration completed": "کالیبراسیون انجام شد.",
            "The experiment will start shortly": "آزمون به زودی آغاز خواهد شد.",
            "uploaded please wait": "% بارگذاری شد... لطفاً صبر کنید",
            "Uploading experiment recording": "در حال بارگذاری ضبط آزمایش"
        },
        "french": {
            "Allow mic access": "Autoriser l'accès au microphone.",
            "Mic is not available": "Le microphone n'est pas disponible. L'expérience ne peut pas continuer.",
            "Calibration required": "Calibration requise.",
            "Read out loud these sentences": "<b>Lisez à voix haute ces phrases :</b> <br>Il n'y a rien que tu puisses faire qui ne puisse être fait<br>Rien que tu ne puisses chanter qui ne puisse être chanté<br>Rien que tu puisses dire mais tu peux apprendre à jouer le jeu<br>C'est facile<br>La calibration se terminera dans",
            "seconds": "secondes",
            "We could not detect your voice": "Nous n'avons pas pu détecter votre voix.",
            "Please increase your mic volume": "Veuillez augmenter le volume de votre micro et actualiser la page pour réessayer.",
            "Calibration completed": "Étalonnage terminé.",
            "The experiment will start shortly": "L'expérience commencera sous peu.",
            "uploaded please wait": "% téléversé... veuillez patienter",
            "Uploading experiment recording": "Téléchargement de l'enregistrement de l'expérience"
        },
        "german": {
            "Allow mic access": "Mikrofonzugriff erlauben.",
            "Mic is not available": "Das Mikrofon ist nicht verfügbar. Das Experiment kann nicht fortgesetzt werden.",
            "Calibration required": "Kalibrierung erforderlich.",
            "Read out loud these sentences": "<b>Lies diese Sätze laut vor:</b> <br>Es gibt nichts, was du tun kannst, das nicht getan werden kann<br>Nichts, was du singen kannst, das nicht gesungen werden kann<br>Nichts, was du sagen kannst, aber du kannst lernen, wie man das Spiel spielt<br>Es ist einfach<br>Die Kalibrierung endet in",
            "seconds": "Sekunden",
            "We could not detect your voice": "Wir konnten Ihre Stimme nicht erkennen.",
            "Please increase your mic volume": "Bitte erhöhen Sie die Lautstärke Ihres Mikrofons und aktualisieren Sie die Seite, um es erneut zu versuchen.",
            "Calibration completed": "Kalibrierung abgeschlossen.",
            "The experiment will start shortly": "Das Experiment beginnt in Kürze.",
            "uploaded please wait": "% hochgeladen... bitte warten",
            "Uploading experiment recording": "Hochladen der Experimentaufzeichnung"
        },
        "hebrew": {
            "Allow mic access": "אפשר גישה למיקרופון.",
            "Mic is not available": "המיקרופון אינו זמין. הניסוי לא יכול להמשיך.",
            "Calibration required": "נדרשת כיול.",
            "Read out loud these sentences": "<b>קרא בקול את המשפטים הבאים:</b> <br>אין דבר שאתה יכול לעשות שאי אפשר לעשות<br>אין דבר שאתה יכול לשיר שאי אפשר לשיר<br>אין דבר שאתה יכול לומר, אבל אתה יכול ללמוד איך לשחק את המשחק<br>זה קל<br>הכיול יסתיים בעוד",
            "seconds": "שניות",
            "We could not detect your voice": "לא הצלחנו לזהות את קולך.",
            "Please increase your mic volume": "אנא הגדל את עוצמת המיקרופון שלך ורענן את הדף כדי לנסות שוב.",
            "Calibration completed": "כיול הושלם.",
            "The experiment will start shortly": "הניסוי יתחיל בקרוב.",
            "uploaded please wait": "% מעלה... בבקשה המתן",
            "Uploading experiment recording": "העלאת הקלטת ניסוי"
        },
        "italian": {
            "Allow mic access": "Consenti l'accesso al microfono.",
            "Mic is not available": "Il microfono non è disponibile. L'esperimento non può continuare.",
            "Calibration required": "Calibrazione richiesta.",
            "Read out loud these sentences": "<b>Leggi ad alta voce queste frasi:</b> <br>Non c'è nulla che tu possa fare che non possa essere fatto<br>Nulla che tu possa cantare che non possa essere cantato<br>Nulla che tu possa dire, ma puoi imparare a giocare al gioco<br>È facile<br>La calibrazione finirà in",
            "seconds": "secondi",
            "We could not detect your voice": "Non siamo riusciti a rilevare la tua voce.",
            "Please increase your mic volume": "Per favore, aumenta il volume del microfono e aggiorna la pagina per riprovare.",
            "Calibration completed": "Calibrazione completata.",
            "The experiment will start shortly": "L'esperimento inizierà a breve.",
            "uploaded please wait": "% caricamento in corso... per favore attendi",
            "Uploading experiment recording": "Caricamento della registrazione dell'esperimento"
        },
        "portuguese": {
            "Allow mic access": "Permitir acesso ao microfone.",
            "Mic is not available": "O microfone não está disponível. O experimento não pode continuar.",
            "Calibration required": "Calibração necessária.",
            "Read out loud these sentences": "<b>Leia em voz alta estas frases:</b> <br>Não há nada que você possa fazer que não possa ser feito<br>Nada que você possa cantar que não possa ser cantado<br>Nada que você possa dizer, mas você pode aprender a jogar o jogo<br>É fácil<br>A calibração terminará em",
            "seconds": "segundos",
            "We could not detect your voice": "Não conseguimos detectar sua voz.",
            "Please increase your mic volume": "Por favor, aumente o volume do seu microfone e atualize a página para tentar novamente.",
            "Calibration completed": "Calibração concluída.",
            "The experiment will start shortly": "O experimento começará em breve.",
            "uploaded please wait": "% carregando... por favor, aguarde",
            "Uploading experiment recording": "Carregando gravação do experimento"
        },
        "spanish": {
            "Allow mic access": "Permitir acceso al micrófono.",
            "Mic is not available": "El micrófono no está disponible. El experimento no puede continuar.",
            "Calibration required": "Se requiere calibración.",
            "Read out loud these sentences": "<b>Lee en voz alta estas oraciones:</b> <br>No hay nada que puedas hacer que no se pueda hacer<br>Nada que puedas cantar que no se pueda cantar<br>Nada que puedas decir, pero puedes aprender cómo jugar el juego<br>Es fácil<br>La calibración terminará en",
            "seconds": "segundos",
            "We could not detect your voice": "No pudimos detectar tu voz.",
            "Please increase your mic volume": "Por favor, aumenta el volumen de tu micrófono y actualiza la página para intentarlo de nuevo.",
            "Calibration completed": "Calibración completada.",
            "The experiment will start shortly": "El experimento comenzará en breve.",
            "uploaded please wait": "% subido... por favor, espera",
            "Uploading experiment recording": "Cargando grabación del experimento"
        },
        "turkish": {
            "Allow mic access": "Mikrofon erişimine izin verin.",
            "Mic is not available": "Mikrofon mevcut değil. Deney devam edemez.",
            "Calibration required": "Kalibrasyon gerekiyor.",
            "Read out loud these sentences": "<b>Bu cümleleri yüksek sesle okuyun:</b><br>Yapamayacağın hiçbir şey yok<br>Söyleyemeyeceğin hiçbir şarkı yok<br>Söyleyebileceğin bir şey yok ama oyunu nasıl oynayacağını öğrenebilirsin<br>Bu kolay<br>Kalibrasyon şu sürede sona erecek",
            "seconds": "saniyeler",
            "We could not detect your voice": "Sesinizi algılayamadık.",
            "Please increase your mic volume": "Lütfen mikrofon sesinizi yükseltin ve tekrar denemek için sayfayı yenileyin.",
            "Calibration completed": "Kalibrasyon tamamlandı.",
            "The experiment will start shortly": "Deney kısa süre içinde başlayacak.",
            "uploaded please wait": "% yükleniyor... lütfen bekleyin",
            "Uploading experiment recording": "Deney kaydını yüklüyor"
        }
    },
    "forms": {
        "english": {
            "Required": "Required",
            "You need to fill in all required answers first": "You need to fill in all required answers first"
        },
        "german": {
            "Required": "Angabe erforderlich",
            "You need to fill in all required answers first": "Sie müssen zuerst alle erforderlichen Antworten ausfüllen"
        },
        "italian": {
            "Required": "Questo campo è obbligatorio",
            "You need to fill in all required answers first": "È necessario compilare in tutte le risposte richieste prima"
        },
        "korean": {
            "Required": "필수",
            "You need to fill in all required answers first": "모든 필수 답변을 먼저 작성해야 합니다."
        },
        "vietnamese": {
            "Required": "Bắt buộc",
            "You need to fill in all required answers first": "Bạn cần điền tất cả các câu trả lời bắt buộc trước tiên."
        },
        "japanese": {
            "Required": "必須",
            "You need to fill in all required answers first": "最初に必須項目に回答する必要があります"
        },
        "mandarin": {
            "Required": "必需",
            "You need to fill in all required answers first": "您需要先填写所有必填答案。"
        },
        "arabic": {
            "Required": "مطلوب",
            "You need to fill in all required answers first": "يجب عليك ملء جميع الإجابات المطلوبة أولاً."
        },
        "dutch": {
            "Required": "Vereist",
            "You need to fill in all required answers first": "U moet eerst alle vereiste antwoorden invullen."
        },
        "farsi": {
            "Required": "مورد نیاز",
            "You need to fill in all required answers first": "ابتدا باید تمام پاسخ‌های الزامی را پر کنید."
        },
        "french": {
            "Required": "Requis",
            "You need to fill in all required answers first": "Vous devez d'abord remplir toutes les réponses obligatoires."
        },
        "hebrew": {
            "Required": "נדרש",
            "You need to fill in all required answers first": "עליך למלא קודם את כל התשובות הנדרשות."
        },
        "portuguese": {
            "Required": "Obrigatório",
            "You need to fill in all required answers first": "Você precisa preencher todas as respostas obrigatórias primeiro."
        },
        "spanish": {
            "Required": "Requerido",
            "You need to fill in all required answers first": "Primero debes completar todas las respuestas obligatorias."
        },
        "turkish": {
            "Required": "Gerekli",
            "You need to fill in all required answers first": "Öncelikle tüm zorunlu soruları yanıtlamanız gerekiyor."
        }
    },
    "errors": {
        "english": {
            "The experiment is not designed to work on this device": "The experiment is not designed to work on this device."
        },
        "turkish": {
            "The experiment is not designed to work on this device": "Deney, bu cihazda çalışmak üzere tasarlanmamıştır."
        },
        "korean": {
            "The experiment is not designed to work on this device": "이 실험은 이 기기에서 작동하도록 설계되지 않았습니다."
        },
        "vietnamese": {
            "The experiment is not designed to work on this device": "Thí nghiệm này không được thiết kế để hoạt động trên thiết bị này."
        },
        "japanese": {
            "The experiment is not designed to work on this device": "本実験はこのデバイスでは実施できません。"
        },
        "mandarin": {
            "The experiment is not designed to work on this device": "该实验并未设计用于此设备。"
        },
        "arabic": {
            "The experiment is not designed to work on this device": "التجربة غير مصممة للعمل على هذا الجهاز."
        },
        "dutch": {
            "The experiment is not designed to work on this device": "Het experiment is niet ontworpen om op dit apparaat te werken."
        },
        "farsi": {
            "The experiment is not designed to work on this device": "این آزمایش برای کار بر روی این دستگاه طراحی نشده است."
        },
        "french": {
            "The experiment is not designed to work on this device": "L'expérience n'est pas conçue pour fonctionner sur cet appareil."
        },
        "german": {
            "The experiment is not designed to work on this device": "Dieses Experiment ist nicht dafür ausgelegt, auf diesem Gerät zu funktionieren."
        },
        "hebrew": {
            "The experiment is not designed to work on this device": "הניסוי אינו מתוכנן לעבוד על מכשיר זה."
        },
        "italian": {
            "The experiment is not designed to work on this device": "L'esperimento non è progettato per funzionare su questo dispositivo."
        },
        "portuguese": {
            "The experiment is not designed to work on this device": "O experimento não foi projetado para funcionar neste dispositivo."
        },
        "spanish": {
            "The experiment is not designed to work on this device": "El experimento no está diseñado para funcionar en este dispositivo."
        }
    },
    "auto_redirect": {
        "english": "You will be automatically redirected in 5 seconds.",
        "mandarin": "您将在5秒钟后自动重定向。",
        "korean": "5초 후 자동으로 리디렉션됩니다.",
        "vietnamese": "Bạn sẽ được tự động chuyển hướng sau 5 giây.",
        "japanese": "5秒後に自動的にリダイレクトされます。",
        "arabic": "سيتم توجيهك تلقائيًا خلال 5 ثوانٍ.",
        "dutch": "U wordt automatisch doorgestuurd over 5 seconden.",
        "farsi": "شما به طور خودکار ظرف ۵ ثانیه هدایت خواهید شد.",
        "french": "Vous serez automatiquement redirigé dans 5 secondes.",
        "german": "Sie werden in 5 Sekunden automatisch weitergeleitet.",
        "hebrew": "תועבר אוטומטית בעוד 5 שניות.",
        "italian": "Sarai reindirizzato automaticamente tra 5 secondi.",
        "portuguese": "Você será redirecionado automaticamente em 5 segundos.",
        "spanish": "Serás redirigido automáticamente en 5 segundos.",
        "turkish": "5 saniye içinde otomatik olarak yönlendirileceksiniz."
    },
    "screenout": {
        "english": {
            "text": "Unfortunately, you do not meet the criteria required to take part in this study. Thank you for your attempt."
        },
        "mandarin": {
            "text": "很遗憾，您不符合参与此研究的条件。感谢您的尝试。"
        },
        "korean": {
            "text": "죄송하지만, 귀하는 이 연구에 참여하기 위한 기준을 충족하지 못하였습니다. 시도해 주셔서 감사합니다."
        },
        "vietnamese": {
            "text": "Rất tiếc, bạn không đáp ứng các tiêu chí cần thiết để tham gia vào nghiên cứu này. Cảm ơn bạn đã thử sức."
        },
        "japanese": {
            "text": "念ながら、本実験の参加基準を満たしていません。ご協力ありがとうございました。"
        },
        "arabic": {
            "text": "للأسف، أنت لا تستوفي المعايير المطلوبة للمشاركة في هذه الدراسة. نشكرك على محاولتك."
        },
        "dutch": {
            "text": "Helaas voldoet u niet aan de criteria om deel te nemen aan dit onderzoek. Bedankt voor uw poging."
        },
        "farsi": {
            "text": "متأسفانه، شما معیارهای لازم برای شرکت در این مطالعه را ندارید. از تلاش شما سپاسگزاریم."
        },
        "french": {
            "text": "Malheureusement, vous ne remplissez pas les critères requis pour participer à cette étude. Merci pour votre tentative."
        },
        "german": {
            "text": "Leider erfüllen Sie nicht die Voraussetzungen, um an dieser Studie teilzunehmen. Vielen Dank für Ihren Versuch."
        },
        "hebrew": {
            "text": "לצערנו, אינך עומד בקריטריונים הנדרשים להשתתפות במחקר זה. תודה על ניסיונך."
        },
        "italian": {
            "text": "Purtroppo, non soddisfi i criteri richiesti per partecipare a questo studio. Grazie per il tuo tentativo."
        },
        "portuguese": {
            "text": "Infelizmente, você não atende aos critérios necessários para participar deste estudo. Obrigado pela sua tentativa."
        },
        "spanish": {
            "text": "Lamentablemente, no cumple con los criterios necesarios para participar en este estudio. Gracias por su intento."
        },
        "turkish": {
            "text": "Maalesef, bu çalışmaya katılmak için gereken kriterleri karşılamıyorsunuz. Gösterdiğiniz çaba için teşekkür ederiz."
        }
    },
    "timeout": {
        "english": {
            "text": "Unfortunately, you've gone over the maximum allowed time to take part in this study. Thank you for your attempt."
        },
        "japanese": {
            "text": "残念ながら、この研究に参加するための最大許容時間を超えています。ご協力ありがとうございました。"
        },
        "mandarin": {
            "text": "很遗憾，您已超过了参加本研究的允许时间。感谢您的参与尝试。"
        },
        "arabic": {
            "text": "للأسف، لقد تجاوزت الحد الأقصى المسموح به للمشاركة في هذه الدراسة. شكرًا لك على محاولتك."
        },
        "dutch": {
            "text": "Helaas heb je de maximum toegestane tijd overschreden om deel te nemen aan dit onderzoek. Bedankt voor je poging."
        },
        "farsi": {
            "text": "متأسفانه، شما از حداکثر زمان مجاز برای شرکت در این مطالعه عبور کرده‌اید. از تلاش شما سپاسگزاریم."
        },
        "french": {
            "text": "Malheureusement, vous avez dépassé le temps maximum autorisé pour participer à cette étude. Merci pour votre essai."
        },
        "german": {
            "text": "Leider haben Sie die maximal zulässige Zeit für die Teilnahme an dieser Studie überschritten. Vielen Dank für Ihren Versuch."
        },
        "hebrew": {
            "text": "לצערנו, חרגת מהזמן המוקצב להשתתפות במחקר זה. תודה על ניסיונך."
        },
        "italian": {
            "text": "Purtroppo hai superato il tempo massimo consentito per partecipare a questo studio. Grazie per il tuo tentativo."
        },
        "korean": {
            "text": "죄송하지만, 본 연구에 참여할 수 있는 최대 시간을 초과하셨습니다. 시도해 주셔서 감사합니다."
        },
        "portuguese": {
            "text": "Infelizmente, você ultrapassou o tempo máximo permitido para participar deste estudo. Agradecemos sua tentativa."
        },
        "spanish": {
            "text": "Lamentablemente, has excedido el tiempo máximo permitido para participar en este estudio. Gracias por tu intento."
        },
        "turkish": {
            "text": "Ne yazık ki, bu çalışmaya katılmak için izin verilen maksimum süreyi aştınız. Katılımınız için teşekkür ederiz."
        },
        "vietnamese": {
            "text": "Rất tiếc, bạn đã vượt quá thời gian cho phép để tham gia nghiên cứu này. Cảm ơn bạn đã cố gắng."
        }
    },
    "boxes": {
        "english": {
            "required": "Please provide a response for each box.",
            "sum": "Response does not add up to expected sum.",
            "min": "There's at least one response with a value smaller than the minimum accepted value.",
            "max": "There's at least one response with a value higher than the maximum accepted value.",
            "pattern": "You must provide a response matching the required format.",
        },
        "japanese": {
            "required": "各項目ごとに回答をお願いします。",
            "sum": "回答が期待値に達しません。",
            "min": "許容最小値より小さい値を持つ回答が少なくとも1つあります。",
            "max": "許容最大値より大きい値を持つ回答が少なくとも1つあります。",
            "pattern": "指定された形式に一致する回答を入力してください。",
        },
        "mandarin": {
            "required": "请在每个框中填写您的回答。",
            "sum": "响应结果与预期总和不符。",
            "min": "至少有一个响应的值小于可接受的最小值。",
            "max": "至少有一个响应的值高于可接受的最大值。",
            "pattern": "您必须提供符合要求格式的回答。",
        },
        "arabic": {
            "required": "يرجى تقديم إجابة لكل مربع.",
            "sum": "الاستجابة لا تتطابق مع المجموع المتوقع.",
            "min": "هناك استجابة واحدة على الأقل بقيمة أقل من الحد الأدنى المقبول.",
            "max": "هناك على الأقل استجابة واحدة بقيمة أعلى من القيمة القصوى المقبولة.",
            "pattern": "يجب عليك تقديم إجابة تطابق الصيغة المطلوبة."
        },
        "dutch": {
            "required": "Gelieve voor elk vakje een antwoord te geven.",
            "sum": "De reactie komt niet overeen met de verwachte som.",
            "min": "Er is minstens één reactie met een waarde kleiner dan de minimaal geaccepteerde waarde.",
            "max": "Er is minstens één reactie met een waarde die hoger is dan de maximaal geaccepteerde waarde.",
            "pattern": "Je moet een antwoord geven dat overeenkomt met het vereiste formaat.",
        },
        "farsi": {
            "required": "لطفاً برای هر کادر یک پاسخ ارائه دهید.",
            "sum": "پاسخ با مجموع مورد انتظار مطابقت ندارد.",
            "min": "حداقل یک پاسخ با مقداری کمتر از مقدار پذیرفته شده وجود دارد.",
            "max": "حداقل یک پاسخ با مقداری بالاتر از حداکثر مقدار پذیرفته شده وجود دارد.",
            "pattern": "شما باید پاسخی ارائه دهید که با قالب مورد نیاز مطابقت داشته باشد.",
        },
        "french": {
            "required": "Veuillez fournir une réponse pour chaque case.",
            "sum": "La réponse ne correspond pas à la somme attendue.",
            "min": "Il y a au moins une réponse avec une valeur inférieure à la valeur minimale acceptée.",
            "max": "Il y a au moins une réponse avec une valeur supérieure à la valeur maximale acceptée.",
            "pattern": "Vous devez fournir une réponse correspondant au format requis.",
        },
        "german": {
            "required": "Bitte geben Sie eine Antwort für jedes Feld ein.",
            "sum": "Die Antwort ergibt nicht die erwartete Summe.",
            "min": "Es gibt mindestens eine Antwort mit einem Wert, der kleiner ist als der minimal akzeptierte Wert.",
            "max": "Es gibt mindestens eine Antwort mit einem Wert, der höher ist als der maximal akzeptierte Wert.",
            "pattern": "Sie müssen eine Antwort geben, die dem erforderlichen Format entspricht.",
        },
        "hebrew": {
            "required": "אנא ספק תגובה עבור כל תיבה.",
            "sum": "תגובה אינה מסתכמת בסכום הצפוי.",
            "min": "יש לפחות תגובה אחת עם ערך קטן מהערך המינימלי המתקבל.",
            "max": "ישנה לפחות תגובה אחת בעלת ערך גבוה מהערך המקסימלי המקובל.",
            "pattern": "עליך לספק תשובה התואמת את הפורמט הנדרש.",
        },
        "italian": {
            "required": "Si prega di fornire una risposta per ogni casella.",
            "sum": "La risposta non raggiunge la somma attesa.",
            "min": "C'è almeno una risposta con un valore inferiore al valore minimo accettato.",
            "max": "C'è almeno una risposta con un valore superiore al valore massimo accettato.",
            "pattern": "Devi fornire una risposta che corrisponda al formato richiesto.",
        },
        "korean": {
            "required": "각 항목에 응답을 작성해주세요.",
            "sum": "응답이 예상한 합계와 일치하지 않습니다.",
            "min": "최소 허용 값보다 작은 값이 있는 응답이 적어도 하나 있습니다.",
            "max": "최대 허용 값을 초과하는 값이 포함된 응답이 적어도 하나 있습니다.",
            "pattern": "요구된 형식에 맞는 응답을 제공해야 합니다.",
        },
        "portuguese": {
            "required": "Por favor, forneça uma resposta para cada campo.",
            "sum": "A resposta não corresponde à soma esperada.",
            "min": "Há pelo menos uma resposta com um valor menor do que o valor mínimo aceito.",
            "max": "Há pelo menos uma resposta com um valor superior ao valor máximo aceito.",
            "pattern": "Você deve fornecer uma resposta que corresponda ao formato exigido.",
        },
        "spanish": {
            "required": "Por favor, proporcione una respuesta para cada cuadro.",
            "sum": "La respuesta no suma el total esperado.",
            "min": "Hay al menos una respuesta con un valor menor que el valor mínimo aceptado.",
            "max": "Hay al menos una respuesta con un valor superior al valor máximo aceptado.",
            "pattern": "Debe proporcionar una respuesta que coincida con el formato requerido.",
        },
        "turkish": {
            "required": "Lütfen her kutucuk için bir yanıt verin.",
            "sum": "Yanıt beklenen toplamı vermiyor.",
            "min": "En az bir yanıt, kabul edilen minimum değerden daha küçük bir değere sahiptir.",
            "max": "Maksimum kabul edilen değerden daha yüksek bir değere sahip en az bir yanıt var.",
            "pattern": "Gerekli biçime uygun bir yanıt vermelisiniz.",
        },
        "vietnamese": {
            "required": "Vui lòng cung cấp câu trả lời cho mỗi ô.",
            "sum": "Phản hồi không cộng lại thành tổng mong đợi.",
            "min": "Có ít nhất một câu trả lời có giá trị nhỏ hơn giá trị tối thiểu được chấp nhận.",
            "max": "Có ít nhất một câu trả lời có giá trị cao hơn giá trị tối đa được chấp nhận.",
            "pattern": "Bạn phải cung cấp câu trả lời theo đúng định dạng yêu cầu.",
        }
    }
}